import { useState, useEffect, useRef } from "react";
import axios from "axios";

const API = process.env.REACT_APP_API || "https://www.vilaro.ro/api";

const card = {
  background: "rgba(255,255,255,0.03)",
  border: "1px solid rgba(255,255,255,0.08)",
};

const inputStyle = {
  background: "rgba(255,255,255,0.04)",
  border: "1px solid rgba(255,255,255,0.1)",
  color: "white",
  outline: "none",
};

const btnPrimary = {
  background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
  color: "white",
};

const btnGray = {
  background: "rgba(255,255,255,0.06)",
  border: "1px solid rgba(255,255,255,0.08)",
  color: "rgba(255,255,255,0.7)",
};

const btnRed = {
  background: "rgba(239,68,68,0.1)",
  border: "1px solid rgba(239,68,68,0.2)",
  color: "#fca5a5",
};

const btnYellow = {
  background: "rgba(234,179,8,0.15)",
  border: "1px solid rgba(234,179,8,0.3)",
  color: "#fde047",
};

const btnGreen = {
  background: "rgba(34,197,94,0.15)",
  border: "1px solid rgba(34,197,94,0.3)",
  color: "#86efac",
};

function getDaysUntilExpiry(expiresAt) {
  if (!expiresAt) return null;
  return Math.floor((new Date(expiresAt) - new Date()) / (1000 * 60 * 60 * 24));
}

function ExpiryBadge({ expiresAt }) {
  const days = getDaysUntilExpiry(expiresAt);
  if (days === null) return null;
  if (days < 0) return <span className="text-xs px-2 py-0.5 rounded-full" style={{background:"rgba(239,68,68,0.15)",color:"#fca5a5"}}>Expirat!</span>;
  if (days <= 7) return <span className="text-xs px-2 py-0.5 rounded-full" style={{background:"rgba(239,68,68,0.15)",color:"#fca5a5"}}>Expira in {days} zile!</span>;
  if (days <= 14) return <span className="text-xs px-2 py-0.5 rounded-full" style={{background:"rgba(234,179,8,0.15)",color:"#fde047"}}>Expira in {days} zile</span>;
  return <span className="text-xs px-2 py-0.5 rounded-full" style={{background:"rgba(34,197,94,0.15)",color:"#86efac"}}>Valabil {days} zile</span>;
}

const pageTypeStyles = {
  official: { background:"rgba(99,102,241,0.15)", color:"#a5b4fc" },
  support: { background:"rgba(34,197,94,0.15)", color:"#86efac" },
  thematic: { background:"rgba(139,92,246,0.15)", color:"#c4b5fd" },
  reaction: { background:"rgba(239,68,68,0.15)", color:"#fca5a5" },
};

// PageCard definit in afara componentei principale - fix bug 5
const PageCard = ({ page, onSync, onToggle, onUpdate, onOpenContext, onToggleAutopilot }) => (
  <div className="rounded-xl p-4 transition-all" style={{...card, opacity: page.is_active ? 1 : 0.5}}>
    <div className="flex justify-between items-start mb-3">
      <div className="flex-1">
        <div className="flex items-center gap-2 mb-1 flex-wrap">
          <h4 className="font-semibold text-sm text-white">{page.name}</h4>
          <span className="text-xs px-2 py-0.5 rounded-full" style={pageTypeStyles[page.page_type] || {background:"rgba(255,255,255,0.06)",color:"rgba(255,255,255,0.5)"}}>
            {page.page_type}
          </span>
          {!page.is_active && <span className="text-xs" style={{color:"#fca5a5"}}>Dezactivata</span>}
        </div>
        <p className="text-xs" style={{color:"rgba(255,255,255,0.25)"}}>ID: {page.id}</p>
      </div>
      <div className="flex gap-1.5 ml-2 flex-wrap justify-end">
        <button onClick={() => onSync(page)}
          className="px-2 py-1.5 rounded-xl text-xs font-medium"
          style={{background:"rgba(99,102,241,0.15)",border:"1px solid rgba(99,102,241,0.3)",color:"#a5b4fc"}}>
          🔄
        </button>
        <button
          onClick={() => onToggleAutopilot(page.id, page.autopilot_replies)}
          className="px-2 py-1.5 rounded-xl text-xs font-medium"
          title="Pilot automat raspunsuri"
          style={page.autopilot_replies
            ? {background:"rgba(34,197,94,0.15)",border:"1px solid rgba(34,197,94,0.3)",color:"#86efac"}
            : {background:"rgba(255,255,255,0.05)",border:"1px solid rgba(255,255,255,0.1)",color:"rgba(255,255,255,0.35)"}}>
          🤖
        </button>
        <button onClick={() => onToggle(page.id, page.account_id)}
          className="px-2 py-1.5 rounded-xl text-xs font-medium"
          style={page.is_active ? btnRed : btnGreen}>
          {page.is_active ? "OFF" : "ON"}
        </button>
      </div>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
      <div>
        <label className="text-xs mb-1 block" style={{color:"rgba(255,255,255,0.35)"}}>Tip pagina</label>
        <select className="w-full rounded-lg px-2 py-1.5 text-xs" style={inputStyle}
          value={page.page_type} onChange={e => onUpdate(page.id, "page_type", e.target.value)}>
          <option style={{color:"black"}} value="official">Official</option>
          <option style={{color:"black"}} value="support">Support</option>
          <option style={{color:"black"}} value="thematic">Thematic</option>
          <option style={{color:"black"}} value="reaction">Reaction</option>
          <option style={{color:"black"}} value="comment_support">Comment Support</option>
        </select>
      </div>
      <div>
        <label className="text-xs mb-1 block" style={{color:"rgba(255,255,255,0.35)"}}>Ton</label>
        <select className="w-full rounded-lg px-2 py-1.5 text-xs" style={inputStyle}
          value={page.tone} onChange={e => onUpdate(page.id, "tone", e.target.value)}>
          <option style={{color:"black"}} value="official">Official</option>
          <option style={{color:"black"}} value="popular">Popular</option>
          <option style={{color:"black"}} value="neutral">Neutral</option>
          <option style={{color:"black"}} value="combative">Combative</option>
        </select>
      </div>
      <div>
        <label className="text-xs mb-1 block" style={{color:"rgba(255,255,255,0.35)"}}>Context AI</label>
        <button
          onClick={() => onOpenContext(page)}
          className="w-full rounded-lg px-2 py-1.5 text-xs text-left truncate"
          style={{...inputStyle, cursor:"pointer", color: page.context ? "rgba(255,255,255,0.7)" : "rgba(255,255,255,0.3)"}}>
          {page.context ? page.context.substring(0, 40) + (page.context.length > 40 ? "..." : "") : "✏️ Click pentru a edita..."}
        </button>
      </div>
    </div>
  </div>
);

export default function Configuration() {
  const [accounts, setAccounts] = useState([]);
  const [pwIdentities, setPwIdentities] = useState([]);
  const [pwLoading, setPwLoading] = useState({});
  const [showCookiesModal, setShowCookiesModal] = useState(null); // accountId
  const [cookiesJson, setCookiesJson] = useState("");
  const [cookiesMessage, setCookiesMessage] = useState("");
  const [domains, setDomains] = useState([]);
  const [pages, setPages] = useState([]);
  const [activeSection, setActiveSection] = useState("accounts");
  const [slaSettings, setSlaSettings] = useState({ sla_yellow_hours: 1, sla_red_hours: 3 });
  const [slaMessage, setSlaMessage] = useState("");
  const [slaLoading, setSlaLoading] = useState(false);
  const [showAddAccount, setShowAddAccount] = useState(false);
  const [showAddDomain, setShowAddDomain] = useState(false);
  const [refreshingAccount, setRefreshingAccount] = useState(null);
  const [showDeleteAccount, setShowDeleteAccount] = useState(null);
  const [showDeleteDomain, setShowDeleteDomain] = useState(null);
  const [newAccount, setNewAccount] = useState({ name: "", user_token: "" });
  const [newDomain, setNewDomain] = useState({ name: "", description: "", color: "#6366f1" });
  const [refreshToken, setRefreshToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [showSyncModal, setShowSyncModal] = useState(null);
  const [showSyncAccountModal, setShowSyncAccountModal] = useState(null);
  const [syncAccountProgress, setSyncAccountProgress] = useState({step: "", current_page: 0, total_pages: 0, page_name: ""});
  const [syncingAccount, setSyncingAccount] = useState(false);
  const [syncAccountResult, setSyncAccountResult] = useState(null);
  const [syncOptions, setSyncOptions] = useState({ limit: 25, fetch_posts: true, fetch_reactions: true, fetch_comments: true });
  const [syncing, setSyncing] = useState(false);
  const [syncResult, setSyncResult] = useState(null);
  const [syncProgress, setSyncProgress] = useState({ step: "", current: 0, total_posts: 0 });
  const [message, setMessage] = useState("");
  const [aiSubTab, setAiSubTab] = useState("modele");
  const [promptSettings, setPromptSettings] = useState({
    prompt_sustinator: "",
    prompt_critic: "",
    prompt_troll: "",
    prompt_intrebare: "",
    prompt_neutru: "",
    post_length: "medie"
  });

  const [aiSettings, setAiSettings] = useState({
    classify_provider: "anthropic",
    classify_model: "claude-sonnet-4-6",
    generate_provider: "anthropic",
    generate_model: "claude-haiku-4-5-20251001",
    openai_api_key: "",
    anthropic_api_key: ""
  });
  const [savingAi, setSavingAi] = useState(false);
  const [users, setUsers] = useState([]);
  const [newUser, setNewUser] = useState({ username: "", password: "", role: "operator" });
  const [showAddUser, setShowAddUser] = useState(false);
  const [userMessage, setUserMessage] = useState("");
  const [editUser, setEditUser] = useState(null);
  const [permissionsUser, setPermissionsUser] = useState(null);
  const [whitelist, setWhitelist] = useState([]);
  const [whitelistGroups, setWhitelistGroups] = useState([]);
  const [whitelistManagers, setWhitelistManagers] = useState([]);
  const [expandedManagers, setExpandedManagers] = useState({});
  // Bulk import state
  const [showBulkImport, setShowBulkImport] = useState(false);
  const [bulkText, setBulkText] = useState("");
  const [bulkManager, setBulkManager] = useState("");
  const [bulkResults, setBulkResults] = useState([]);
  const [bulkSelected, setBulkSelected] = useState({});
  const [bulkSearching, setBulkSearching] = useState(false);
  const [bulkAdding, setBulkAdding] = useState(false);
  // Edit manager per item
  const [editingItem, setEditingItem] = useState(null);
  const [editingMgrValue, setEditingMgrValue] = useState("");
  const [editingMgrSaving, setEditingMgrSaving] = useState(false);
  const [newWhitelistUser, setNewWhitelistUser] = useState({ from_id: "", from_name: "", notes: "", manager: "" });
  const [showAddWhitelist, setShowAddWhitelist] = useState(false);
  const [whitelistSearch, setWhitelistSearch] = useState([]);
  const [whitelistSearching, setWhitelistSearching] = useState(false); // userul pentru care editam permisiunile
  const [permissionsData, setPermissionsData] = useState(null); // { accounts: [...] }
  const [savingPermissions, setSavingPermissions] = useState(false);
  const [contextModal, setContextModal] = useState(null);
  const [promptModal, setPromptModal] = useState(null);

  // Refs pentru polling - fix bug 1 si 2
  const syncPollRef = useRef(null);
  const syncAccountPollRef = useRef(null);

  useEffect(() => { fetchAll(); }, []);

  useEffect(() => {
    if (activeSection === "playwright") fetchPwIdentities();
  }, [activeSection]);

  const fetchAll = async () => { 
    await Promise.all([fetchAccounts(), fetchDomains(), fetchPages()]);
    const res = await axios.get(`${API}/settings`);
    setAiSettings(prev => ({...prev, ...res.data}));
    setPromptSettings({
      prompt_post: res.data.prompt_post || "Scrie postarea în limba română. Folosește un limbaj direct, convingător și adaptat publicului de pe Facebook. Evită clișeele politice. Include un call-to-action la final.",
      prompt_sustinator: res.data.prompt_sustinator || "Comentatorul este un susținător. Răspunde cu căldură, mulțumește-i și încurajează-l.",
      prompt_critic: res.data.prompt_critic || "Comentatorul este un critic. Răspunde ferm, contraargumentează bazat pe fapte, fii puțin agresiv dar argumentat. Nu te scuza.",
      prompt_troll: res.data.prompt_troll || "Comentatorul este un trol agresiv. Răspunde agresiv și direct, contraatacă ferm, nu te lăsa intimidat. Fii tăios și sigur pe tine.",
      prompt_intrebare: res.data.prompt_intrebare || "Comentatorul pune o întrebare. Răspunde informativ, clar și direct la întrebare.",
      prompt_neutru: res.data.prompt_neutru || "Comentatorul este neutru. Răspunde scurt și prietenos.",
      post_length: res.data.post_length || "medie"
    });
    const usersRes = await axios.get(`${API}/auth/users`);
    setUsers(usersRes.data.users);
    const wlRes = await axios.get(`${API}/whitelist?grouped=true`);
    setWhitelistGroups(wlRes.data.groups || []);
    // Pentru compat: flatten din groups
    const flat = (wlRes.data.groups || []).flatMap(g => g.items || []);
    setWhitelist(flat);
    try {
      const mgrRes = await axios.get(`${API}/whitelist/managers`);
      setWhitelistManagers(mgrRes.data.managers || []);
    } catch (e) { setWhitelistManagers([]); }
  };
  const fetchAccounts = async () => { const res = await axios.get(`${API}/accounts`); setAccounts(res.data.accounts); };
  
  const fetchPwIdentities = async () => {
    try {
      const res = await axios.get(`${API}/playwright/identities`);
      setPwIdentities(res.data.identities || []);
    } catch(e) { console.error(e); }
  };
  
  const togglePwAccount = async (accountId, currentEnabled) => {
    try {
      await axios.put(`${API}/accounts/${accountId}/playwright-toggle`, { enabled: !currentEnabled });
      await fetchAccounts(); fetchPwIdentities();
      await fetchPwIdentities();
    } catch(e) { alert("Eroare: " + (e.response?.data?.detail || e.message)); }
  };
  
  const savePwCookies = async (accountId) => {
    if (!cookiesJson.trim()) return;
    try {
      // Validare JSON
      try { JSON.parse(cookiesJson); } catch { alert("JSON invalid"); return; }
      
      await axios.put(`${API}/accounts/${accountId}/playwright-cookies`, { cookies_json: cookiesJson });
      setCookiesMessage("✅ Cookies salvate cu succes");
      setTimeout(() => { setShowCookiesModal(null); setCookiesJson(""); setCookiesMessage(""); }, 1500);
      await fetchPwIdentities();
    } catch(e) {
      setCookiesMessage("❌ Eroare: " + (e.response?.data?.detail || e.message));
    }
  };
  
  const touchPwIdentity = async (id) => {
    setPwLoading(prev => ({...prev, [id]: "touch"}));
    try {
      const res = await axios.post(`${API}/playwright/identities/${id}/touch`);
      await fetchPwIdentities();
      if (!res.data.success) alert("Touch a eșuat: " + res.data.error);
    } catch(e) { alert("Eroare: " + e.message); }
    finally { setPwLoading(prev => ({...prev, [id]: null})); }
  };
  
  const healthCheckPwIdentity = async (id) => {
    setPwLoading(prev => ({...prev, [id]: "health"}));
    try {
      const res = await axios.post(`${API}/playwright/identities/${id}/health-check`);
      await fetchPwIdentities();
      if (res.data.success) {
        alert(res.data.is_logged_in ? "✅ Sesiune validă: " + res.data.detail : "❌ Sesiune invalidă: " + res.data.detail);
      }
    } catch(e) { alert("Eroare: " + e.message); }
    finally { setPwLoading(prev => ({...prev, [id]: null})); }
  };
  const fetchDomains = async () => { const res = await axios.get(`${API}/domains`); setDomains(res.data.domains); };
  const fetchPages = async () => { const res = await axios.get(`${API}/pages`); setPages(res.data.pages); };

  const addAccount = async () => {
    setLoading(true); setMessage("");
    try {
      const res = await axios.post(`${API}/accounts`, newAccount);
      setMessage(`Cont adaugat! ${res.data.pages_saved.length} pagini importate.`);
      setNewAccount({ name: "", user_token: "" });
      setShowAddAccount(false);
      await fetchAll();
    } catch (e) {
      setMessage(`Eroare: ${e.response?.data?.detail || "Token invalid!"}`);
    } finally { setLoading(false); }
  };

  const refreshAccountToken = async (accountId) => {
    setLoading(true); setMessage("");
    try {
      await axios.put(`${API}/accounts/${accountId}/refresh-token`, { user_token: refreshToken });
      setMessage("Token reinnoit cu succes!");
      setRefreshingAccount(null); setRefreshToken("");
      await fetchAll();
    } catch (e) {
      setMessage(`Eroare: ${e.response?.data?.detail || "Token invalid!"}`);
    } finally { setLoading(false); }
  };

  // Fix bug 4 - try/catch pentru deleteAccount si deleteDomain
  const deleteAccount = async (id) => {
    try {
      await axios.delete(`${API}/accounts/${id}`);
      setShowDeleteAccount(null);
      await fetchAll();
    } catch (e) {
      setMessage(`Eroare stergere cont: ${e.response?.data?.detail || "Eroare necunoscuta"}`);
      setShowDeleteAccount(null);
    }
  };

  const deleteDomain = async (id) => {
    try {
      await axios.delete(`${API}/domains/${id}`);
      setShowDeleteDomain(null);
      await fetchDomains();
    } catch (e) {
      setMessage(`Eroare stergere domeniu: ${e.response?.data?.detail || "Eroare necunoscuta"}`);
      setShowDeleteDomain(null);
    }
  };

  const togglePage = async (pageId, accountId) => {
    if (accountId) await axios.post(`${API}/accounts/${accountId}/pages/${pageId}/toggle`);
    else await axios.post(`${API}/pages/${pageId}/toggle`);
    await fetchPages();
  };

  const toggleAutopilotReplies = async (pageId, currentValue) => {
    const newValue = currentValue ? 0 : 1;
    const page = pages.find(p => p.id === pageId);
    if (!page) return;
    await axios.put(`${API}/pages/${pageId}`, { ...page, autopilot_replies: newValue });
    await fetchPages();
  };

  const updatePage = async (pageId, field, value) => {
    const page = pages.find(p => p.id === pageId);
    if (!page) return;
    await axios.put(`${API}/pages/${pageId}`, { ...page, [field]: value });
    await fetchPages();
  };

  // Fix bug 2 - polling cont cu ref
  const syncAccount = async (accountId) => {
    setSyncingAccount(true);
    setSyncAccountResult(null);
    setSyncAccountProgress({step: "Se pornește...", current_page: 0, total_pages: 0, page_name: ""});
    try {
      await axios.post(`${API}/accounts/${accountId}/sync-all`, syncOptions);
      await new Promise(r => setTimeout(r, 500));
      const poll = setInterval(async () => {
        try {
          const res = await axios.get(`${API}/accounts/${accountId}/sync-all-status`);
          const status = res.data;
          setSyncAccountProgress(status);
          if (status.finished === true) {
            clearInterval(poll);
            syncAccountPollRef.current = null;
            setSyncingAccount(false);
            setSyncAccountResult({success: true, pages: status.total_pages});
          }
        } catch (e) {
          clearInterval(poll);
          syncAccountPollRef.current = null;
          setSyncingAccount(false);
          setSyncAccountResult({error: "Eroare la sincronizare!"});
        }
      }, 1000);
      syncAccountPollRef.current = poll;
    } catch (e) {
      setSyncingAccount(false);
      setSyncAccountResult({error: "Eroare la sincronizare!"});
    }
  };

  // Fix bug 1 - polling pagina cu ref
  const syncPage = async (pageId) => {
    setSyncing(true);
    setSyncResult(null);
    setSyncProgress({ step: "Se porneste...", current: 0, total_posts: 0 });
    
    await axios.post(`${API}/pages/${pageId}/sync-reset`).catch(()=>{});
    await axios.post(`${API}/pages/${pageId}/sync`, syncOptions).catch(()=>{});
    
    await new Promise(r => setTimeout(r, 500));
    const poll = setInterval(async () => {
      try {
        const res = await axios.get(`${API}/pages/${pageId}/sync-status`);
        const status = res.data;
        setSyncProgress(status);
        if (status.finished === true) {
          clearInterval(poll);
          syncPollRef.current = null;
          setSyncing(false);
          setSyncResult({ posts: status.posts, reactions: status.reactions, comments: status.comments });
        }
      } catch (e) {
        clearInterval(poll);
        syncPollRef.current = null;
        setSyncing(false);
      }
    }, 1000);
    syncPollRef.current = poll;
  };

  const closeSyncModal = () => {
    if (syncPollRef.current) { clearInterval(syncPollRef.current); syncPollRef.current = null; }
    setShowSyncModal(null);
    setSyncResult(null);
    setSyncing(false);
  };

  const closeSyncAccountModal = () => {
    if (syncAccountPollRef.current) { clearInterval(syncAccountPollRef.current); syncAccountPollRef.current = null; }
    setShowSyncAccountModal(null);
    setSyncAccountResult(null);
    setSyncingAccount(false);
  };

  const handleOpenSyncModal = async (page) => {
    if (syncPollRef.current) { clearInterval(syncPollRef.current); syncPollRef.current = null; }
    await axios.post(`${API}/pages/${page.id}/sync-reset`).catch(()=>{});
    setShowSyncModal(page);
    setSyncResult(null);
    setSyncing(false);
    setSyncProgress({ step: "", current: 0, total_posts: 0 });
  };

  // Fix bug 3 - addDomain cu try/catch
  const addDomain = async () => {
    try {
      await axios.post(`${API}/domains`, newDomain);
      setNewDomain({ name: "", description: "", color: "#6366f1" });
      setShowAddDomain(false);
      await fetchDomains();
    } catch (e) {
      setMessage(`Eroare adaugare domeniu: ${e.response?.data?.detail || "Eroare necunoscuta"}`);
    }
  };

  const saveAiSettings = async () => {
    setSavingAi(true);
    try {
      for (const [key, value] of Object.entries(aiSettings)) {
        if (key === 'openai_api_key' || key === 'anthropic_api_key') continue;
        await axios.put(`${API}/settings/${key}`, { value });
      }
      setMessage("Setări AI salvate cu succes!");
    } catch (e) {
      setMessage("Eroare la salvare setări AI!");
    }
    setSavingAi(false);
  };

  const addUser = async () => {
    try {
      await axios.post(`${API}/auth/create-user`, newUser);
      setUserMessage(`User ${newUser.username} creat cu succes!`);
      setNewUser({ username: "", password: "", role: "operator" });
      setShowAddUser(false);
      const res = await axios.get(`${API}/auth/users`);
      setUsers(res.data.users);
    } catch (e) {
      setUserMessage(`Eroare: ${e.response?.data?.detail || "Eroare necunoscuta"}`);
    }
  };

  const deleteUser = async (userId) => {
    try {
      await axios.delete(`${API}/auth/users/${userId}`);
      const res = await axios.get(`${API}/auth/users`);
      setUsers(res.data.users);
    } catch (e) {
      setUserMessage(`Eroare: ${e.response?.data?.detail || "Eroare necunoscuta"}`);
    }
  };

  const openPermissions = async (user) => {
    setPermissionsUser(user);
    try {
      const res = await axios.get(`${API}/auth/users/${user.id}/permissions`);
      setPermissionsData(res.data);
    } catch (e) {
      console.error(e);
    }
  };

  const savePermissions = async () => {
    if (!permissionsUser || !permissionsData) return;
    setSavingPermissions(true);
    try {
      // Construim lista de permisiuni din starea UI
      const permissions = [];
      for (const acc of permissionsData.accounts) {
        if (!acc.has_access) continue;
        if (acc.all_pages) {
          permissions.push({ account_id: acc.id, page_ids: null });
        } else {
          permissions.push({ account_id: acc.id, page_ids: acc.allowed_page_ids });
        }
      }
      await axios.put(`${API}/auth/users/${permissionsUser.id}/permissions`, permissions);
      setUserMessage(`Permisiuni salvate pentru ${permissionsUser.username}!`);
      setPermissionsUser(null);
      setPermissionsData(null);
    } catch (e) {
      setUserMessage(`Eroare: ${e.response?.data?.detail || "Eroare necunoscuta"}`);
    }
    setSavingPermissions(false);
  };

  const searchWhitelistUser = async (name) => {
    setNewWhitelistUser(prev => ({...prev, from_name: name, from_id: ""}));
    if (name.length < 3) { setWhitelistSearch([]); return; }
    setWhitelistSearching(true);
    try {
      const res = await axios.get(`${API}/whitelist/search?name=${encodeURIComponent(name)}`);
      setWhitelistSearch(res.data.results || []);
    } catch (e) { setWhitelistSearch([]); }
    setWhitelistSearching(false);
  };

  const selectWhitelistUser = (user) => {
    setNewWhitelistUser(prev => ({...prev, from_id: user.from_id, from_name: user.from_name}));
    setWhitelistSearch([]);
  };

  const addToWhitelist = async () => {
    if (!newWhitelistUser.from_id || !newWhitelistUser.from_name) return;
    try {
      await axios.post(`${API}/whitelist`, newWhitelistUser);
      const res = await axios.get(`${API}/whitelist?grouped=true`);
      setWhitelistGroups(res.data.groups || []);
      const flat = (res.data.groups || []).flatMap(g => g.items || []);
      setWhitelist(flat);
      try {
        const mgrRes = await axios.get(`${API}/whitelist/managers`);
        setWhitelistManagers(mgrRes.data.managers || []);
      } catch (e) {}
      setNewWhitelistUser({ from_id: "", from_name: "", notes: "", manager: "" });
      setShowAddWhitelist(false);
      setMessage("User adaugat pe whitelist!");
    } catch (e) {
      setMessage(`Eroare: ${e.response?.data?.detail || "Eroare necunoscuta"}`);
    }
  };

  const doBulkSearch = async () => {
    const names = bulkText.split("\n").map(s => s.trim()).filter(Boolean);
    if (names.length === 0) {
      setMessage("Adaugă cel puțin un nume.");
      return;
    }
    setBulkSearching(true);
    try {
      const res = await axios.post(`${API}/whitelist/bulk-search`, { names });
      const results = res.data.results || [];
      setBulkResults(results);
      // Bifez automat pe cei "found_clean"
      const sel = {};
      results.forEach(r => {
        if (r.status === "found_clean" && r.candidates && r.candidates[0]) {
          sel[r.candidates[0].from_id] = {
            from_id: r.candidates[0].from_id,
            from_name: r.candidates[0].from_name,
          };
        }
      });
      setBulkSelected(sel);
    } catch (e) {
      setMessage("Eroare la căutare: " + (e.response?.data?.detail || e.message));
    }
    setBulkSearching(false);
  };

  const toggleBulkSelected = (candidate) => {
    setBulkSelected(prev => {
      const next = { ...prev };
      if (next[candidate.from_id]) {
        delete next[candidate.from_id];
      } else {
        next[candidate.from_id] = {
          from_id: candidate.from_id,
          from_name: candidate.from_name,
        };
      }
      return next;
    });
  };

  const doBulkAdd = async () => {
    const items = Object.values(bulkSelected);
    if (items.length === 0) {
      setMessage("Niciun user selectat.");
      return;
    }
    setBulkAdding(true);
    try {
      const res = await axios.post(`${API}/whitelist/bulk-add`, {
        items,
        manager: bulkManager || null,
        notes: "Adăugat batch",
      });
      setMessage(`✓ ${res.data.added} adăugați, ${res.data.skipped} omiși. Unhide pe FB: ${res.data.total_unhide} în background.`);
      // Refetch
      const wlRes = await axios.get(`${API}/whitelist?grouped=true`);
      setWhitelistGroups(wlRes.data.groups || []);
      const flat = (wlRes.data.groups || []).flatMap(g => g.items || []);
      setWhitelist(flat);
      try {
        const mgrRes = await axios.get(`${API}/whitelist/managers`);
        setWhitelistManagers(mgrRes.data.managers || []);
      } catch (e) {}
      // Reset modal
      setShowBulkImport(false);
      setBulkText("");
      setBulkManager("");
      setBulkResults([]);
      setBulkSelected({});
    } catch (e) {
      setMessage("Eroare la adăugare: " + (e.response?.data?.detail || e.message));
    }
    setBulkAdding(false);
  };

  const openEditManager = (item) => {
    setEditingItem(item);
    setEditingMgrValue(item.manager || "");
  };

  const saveEditingManager = async () => {
    if (!editingItem) return;
    setEditingMgrSaving(true);
    try {
      await axios.patch(`${API}/whitelist/${editingItem.from_id}`, {
        manager: editingMgrValue.trim(),
      });
      const res = await axios.get(`${API}/whitelist?grouped=true`);
      setWhitelistGroups(res.data.groups || []);
      const flat = (res.data.groups || []).flatMap(g => g.items || []);
      setWhitelist(flat);
      try {
        const mgrRes = await axios.get(`${API}/whitelist/managers`);
        setWhitelistManagers(mgrRes.data.managers || []);
      } catch (e) {}
      setEditingItem(null);
      setEditingMgrValue("");
      setMessage(`✓ Coordonator actualizat pentru ${editingItem.from_name}`);
    } catch (e) {
      setMessage("Eroare: " + (e.response?.data?.detail || e.message));
    }
    setEditingMgrSaving(false);
  };

  const removeFromWhitelist = async (from_id) => {
    try {
      await axios.delete(`${API}/whitelist/${from_id}`);
      const res = await axios.get(`${API}/whitelist?grouped=true`);
      setWhitelistGroups(res.data.groups || []);
      const flat = (res.data.groups || []).flatMap(g => g.items || []);
      setWhitelist(flat);
      setMessage("User eliminat din whitelist!");
    } catch (e) {
      setMessage(`Eroare: ${e.response?.data?.detail || "Eroare necunoscuta"}`);
    }
  };

  const toggleAccountAccess = (accountId) => {
    setPermissionsData(prev => ({
      ...prev,
      accounts: prev.accounts.map(acc =>
        acc.id === accountId
          ? { ...acc, has_access: !acc.has_access, all_pages: !acc.has_access ? true : acc.all_pages }
          : acc
      )
    }));
  };

  const toggleAllPages = (accountId) => {
    setPermissionsData(prev => ({
      ...prev,
      accounts: prev.accounts.map(acc =>
        acc.id === accountId ? { ...acc, all_pages: !acc.all_pages, allowed_page_ids: [] } : acc
      )
    }));
  };

  const togglePageAccess = (accountId, pageId) => {
    setPermissionsData(prev => ({
      ...prev,
      accounts: prev.accounts.map(acc => {
        if (acc.id !== accountId) return acc;
        const ids = acc.allowed_page_ids || [];
        const newIds = ids.includes(pageId) ? ids.filter(id => id !== pageId) : [...ids, pageId];
        return { ...acc, allowed_page_ids: newIds };
      })
    }));
  };

  const sections = [
    { id: "accounts", label: "Conturi Facebook", icon: "👤" },
    { id: "pages", label: "Pagini", icon: "📄" },
    { id: "playwright", label: "Playwright", icon: "🎭" },
    { id: "domains", label: "Domenii", icon: "🏷️" },
    { id: "ai", label: "Setări AI", icon: "🤖" },
    { id: "sla", label: "Alerte Timp Răspuns", icon: "⚠️" },
    { id: "users", label: "Utilizatori", icon: "👥" },
    { id: "whitelist", label: "Whitelist", icon: "⭐" },
  ];

  const fetchSla = async () => {
    try {
      const res = await axios.get(`${API}/settings/sla`);
      setSlaSettings(res.data);
    } catch (e) { console.error(e); }
  };

  const saveSla = async () => {
    setSlaLoading(true); setSlaMessage("");
    try {
      await axios.post(`${API}/settings/sla`, slaSettings);
      setSlaMessage("Setări salvate!");
      setTimeout(() => setSlaMessage(""), 3000);
    } catch (e) { setSlaMessage("Eroare la salvare"); }
    setSlaLoading(false);
  };

  const Modal = ({ title, message: msg, onConfirm, onCancel, confirmStyle, confirmLabel }) => (
    <div className="fixed inset-0 flex items-center justify-center z-50" style={{background:"rgba(0,0,0,0.8)"}}>
      <div className="rounded-2xl p-6 max-w-md w-full mx-4" style={card}>
        <h3 className="text-lg font-bold mb-2 text-white">{title}</h3>
        <p className="text-sm mb-4" style={{color:"rgba(255,255,255,0.5)"}}>{msg}</p>
        <div className="flex gap-3">
          <button onClick={onConfirm} className="flex-1 py-2 rounded-xl text-sm font-medium" style={confirmStyle || btnRed}>{confirmLabel || "Sterge"}</button>
          <button onClick={onCancel} className="flex-1 py-2 rounded-xl text-sm font-medium" style={btnGray}>Anuleaza</button>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      {/* Modal Permisiuni User */}
      {permissionsUser && permissionsData && (
        <div className="fixed inset-0 flex items-center justify-center z-50" style={{background:"rgba(0,0,0,0.85)"}}>
          <div className="rounded-2xl p-6 w-full mx-4 flex flex-col" style={{...card, maxWidth:"600px", maxHeight:"90vh", overflow:"auto"}}>
            <div className="flex items-center justify-between mb-4">
              <div>
                <h3 className="text-lg font-bold text-white">Permisiuni — {permissionsUser.username}</h3>
                <p className="text-xs mt-0.5" style={{color:"rgba(255,255,255,0.35)"}}>
                  Selectează conturile și paginile la care are acces
                </p>
              </div>
              <span className="text-xs px-2 py-1 rounded-lg" style={{background:"rgba(99,102,241,0.15)",color:"#a5b4fc"}}>
                {permissionsUser.role}
              </span>
            </div>

            {permissionsData.accounts.length === 0 && (
              <div className="text-center py-8 text-sm" style={{color:"rgba(255,255,255,0.3)"}}>
                Niciun cont Facebook configurat
              </div>
            )}

            <div className="space-y-4 mb-5">
              {permissionsData.accounts.map(acc => (
                <div key={acc.id} className="rounded-xl p-4" style={{background:"rgba(255,255,255,0.02)",border:"1px solid rgba(255,255,255,0.07)"}}>
                  {/* Header cont */}
                  <div className="flex items-center gap-3 mb-3">
                    <input type="checkbox" checked={acc.has_access}
                      onChange={() => toggleAccountAccess(acc.id)}
                      className="accent-indigo-500 w-4 h-4 cursor-pointer" />
                    <span className="font-semibold text-sm text-white">{acc.name}</span>
                    <span className="text-xs" style={{color:"rgba(255,255,255,0.3)"}}>{acc.pages?.length} pagini</span>
                  </div>

                  {acc.has_access && (
                    <div className="ml-7 space-y-2">
                      {/* Toate paginile toggle */}
                      <label className="flex items-center gap-2 cursor-pointer p-2 rounded-lg"
                        style={{background:"rgba(99,102,241,0.08)",border:"1px solid rgba(99,102,241,0.2)"}}>
                        <input type="checkbox" checked={acc.all_pages}
                          onChange={() => toggleAllPages(acc.id)}
                          className="accent-indigo-500 w-4 h-4 cursor-pointer" />
                        <span className="text-xs font-medium" style={{color:"#a5b4fc"}}>Toate paginile contului</span>
                      </label>

                      {/* Pagini individuale */}
                      {!acc.all_pages && (
                        <div className="grid grid-cols-1 gap-1.5 mt-2">
                          {acc.pages?.map(page => (
                            <label key={page.id}
                              className="flex items-center gap-2 p-2 rounded-lg cursor-pointer"
                              style={acc.allowed_page_ids?.includes(page.id)
                                ? {background:"rgba(34,197,94,0.08)",border:"1px solid rgba(34,197,94,0.2)"}
                                : {background:"rgba(255,255,255,0.02)",border:"1px solid rgba(255,255,255,0.06)"}}>
                              <input type="checkbox"
                                checked={acc.allowed_page_ids?.includes(page.id) || false}
                                onChange={() => togglePageAccess(acc.id, page.id)}
                                className="accent-indigo-500 w-4 h-4 cursor-pointer" />
                              <span className="text-sm" style={{color:"rgba(255,255,255,0.8)"}}>{page.name}</span>
                            </label>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="flex gap-3">
              <button onClick={savePermissions} disabled={savingPermissions}
                className="flex-1 py-2.5 rounded-xl text-sm font-semibold disabled:opacity-50" style={btnPrimary}>
                {savingPermissions ? "Se salvează..." : "Salvează permisiunile"}
              </button>
              <button onClick={() => { setPermissionsUser(null); setPermissionsData(null); }}
                className="flex-1 py-2.5 rounded-xl text-sm font-medium" style={btnGray}>
                Anulează
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Context Pagina */}
      {contextModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50" style={{background:"rgba(0,0,0,0.85)"}}>
          <div className="rounded-2xl p-6 w-full mx-4 flex flex-col" style={{...card, maxWidth:"760px", maxHeight:"90vh"}}>
            <div className="flex justify-between items-center mb-3">
              <div>
                <h3 className="text-lg font-bold text-white">Context AI — {contextModal.name}</h3>
                <p className="text-xs mt-0.5" style={{color:"rgba(255,255,255,0.35)"}}>Textul este injectat în promptul AI la fiecare răspuns generat pentru această pagină</p>
              </div>
              <span className="text-xs" style={{color:"rgba(255,255,255,0.3)"}}>
                {(contextModal.value || "").length} caractere · {(contextModal.value || "").trim().split(/\s+/).filter(Boolean).length} cuvinte
              </span>
            </div>
            <textarea
              className="w-full rounded-xl px-4 py-3 text-sm resize-none mb-4"
              style={{...inputStyle, height:"440px", lineHeight:"1.6", fontFamily:"inherit"}}
              placeholder="Introdu contextul AI pentru această pagină..."
              value={contextModal.value || ""}
              onChange={e => setContextModal(prev => ({...prev, value: e.target.value}))}
              autoFocus
            />
            <div className="flex gap-3">
              <button onClick={() => { updatePage(contextModal.id, "context", contextModal.value); setContextModal(null); }}
                className="flex-1 py-2.5 rounded-xl text-sm font-semibold" style={btnPrimary}>
                Salvează
              </button>
              <button onClick={() => setContextModal(null)}
                className="flex-1 py-2.5 rounded-xl text-sm font-medium" style={btnGray}>
                Anulează
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Prompt AI */}
      {promptModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50" style={{background:"rgba(0,0,0,0.85)"}}>
          <div className="rounded-2xl p-6 w-full mx-4 flex flex-col" style={{...card, maxWidth:"760px", maxHeight:"90vh"}}>
            <div className="flex justify-between items-center mb-3">
              <div>
                <h3 className="text-lg font-bold text-white">
                  <span style={{color: promptModal.color}}>{promptModal.label}</span> — Prompt AI
                </h3>
                <p className="text-xs mt-0.5" style={{color:"rgba(255,255,255,0.35)"}}>Instrucțiuni specifice pentru AI când răspunde la acest tip de comentariu</p>
              </div>
            </div>
            <textarea
              className="w-full rounded-xl px-4 py-3 text-sm resize-none mb-4"
              style={{...inputStyle, height:"340px", lineHeight:"1.6", fontFamily:"inherit"}}
              placeholder="Instrucțiuni pentru AI..."
              value={promptModal.value || ""}
              onChange={e => setPromptModal(prev => ({...prev, value: e.target.value}))}
              autoFocus
            />
            <div className="flex gap-3">
              <button onClick={async () => {
                  await axios.put(`${API}/settings/${promptModal.key}`, {value: promptModal.value});
                  setPromptSettings(prev => ({...prev, [promptModal.key]: promptModal.value}));
                  setMessage("Prompt salvat!");
                  setPromptModal(null);
                }}
                className="flex-1 py-2.5 rounded-xl text-sm font-semibold" style={btnPrimary}>
                Salvează
              </button>
              <button onClick={() => setPromptModal(null)}
                className="flex-1 py-2.5 rounded-xl text-sm font-medium" style={btnGray}>
                Anulează
              </button>
            </div>
          </div>
        </div>
      )}

      {showCookiesModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4" 
             style={{background:"rgba(0,0,0,0.7)"}} onClick={() => { setShowCookiesModal(null); setCookiesJson(""); setCookiesMessage(""); }}>
          <div className="rounded-2xl p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto"
               style={{background:"#0f0f1a",border:"1px solid rgba(255,255,255,0.1)"}}
               onClick={e => e.stopPropagation()}>
            <h3 className="text-lg font-semibold text-white mb-1">🎭 Activează Playwright</h3>
            <p className="text-sm mb-4" style={{color:"rgba(255,255,255,0.5)"}}>{showCookiesModal.name}</p>
            
            <div className="rounded-xl p-3 mb-4" style={{background:"rgba(99,102,241,0.08)",border:"1px solid rgba(99,102,241,0.2)"}}>
              <p className="text-xs leading-relaxed" style={{color:"rgba(255,255,255,0.7)"}}>
                <strong>Pași:</strong><br/>
                1. Pe Mac, instalează extensia <strong>Cookie-Editor</strong> în Chrome<br/>
                2. Loghează-te pe facebook.com cu acest cont<br/>
                3. Click pe extensie → Export → JSON (copiază)<br/>
                4. Lipește JSON-ul mai jos
              </p>
            </div>
            
            <label className="text-xs mb-1 block" style={{color:"rgba(255,255,255,0.4)"}}>JSON Cookies din Cookie-Editor</label>
            <textarea className="w-full rounded-xl px-3 py-2.5 text-sm font-mono resize-y mb-3"
              style={inputStyle}
              placeholder='[{"domain":".facebook.com","name":"c_user",...}, ...]'
              rows={10}
              value={cookiesJson} onChange={e => setCookiesJson(e.target.value)} />
            
            {cookiesMessage && (
              <div className="text-sm mb-3" style={{color: cookiesMessage.startsWith("✅") ? "#86efac" : "#fca5a5"}}>
                {cookiesMessage}
              </div>
            )}
            
            <div className="flex gap-2 justify-between items-center">
              <div>
                {showCookiesModal.playwright_enabled && (
                  <button onClick={() => {
                    if (window.confirm("Sigur dezactivezi Playwright pentru " + showCookiesModal.name + "? Identitățile asociate vor fi dezactivate.")) {
                      togglePwAccount(showCookiesModal.id, true);
                      setShowCookiesModal(null);
                    }
                  }}
                    className="px-4 py-2 rounded-xl text-sm font-medium" style={btnRed}>
                    🚫 Dezactivează Playwright
                  </button>
                )}
              </div>
              <div className="flex gap-2">
                <button onClick={() => { setShowCookiesModal(null); setCookiesJson(""); setCookiesMessage(""); }}
                  className="px-4 py-2 rounded-xl text-sm font-medium" style={btnGray}>
                  Anulează
                </button>
                <button onClick={() => savePwCookies(showCookiesModal.id)}
                  disabled={!cookiesJson.trim()}
                  className="px-4 py-2 rounded-xl text-sm font-medium disabled:opacity-50" style={btnPrimary}>
                  💾 Salvează Cookies
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      
      {showDeleteAccount && (
        <Modal title="Sterge contul"
          message={`Esti sigur ca vrei sa stergi "${showDeleteAccount.name}"? Paginile asociate vor fi dezactivate.`}
          onConfirm={() => deleteAccount(showDeleteAccount.id)}
          onCancel={() => setShowDeleteAccount(null)} />
      )}
      {showDeleteDomain && (
        <Modal title="Sterge domeniul"
          message={`Esti sigur ca vrei sa stergi "${showDeleteDomain.name}"? Campaniile asociate vor ramane fara domeniu.`}
          onConfirm={() => deleteDomain(showDeleteDomain.id)}
          onCancel={() => setShowDeleteDomain(null)} />
      )}

      {showSyncModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50" style={{background:"rgba(0,0,0,0.8)"}}>
          <div className="rounded-2xl p-6 max-w-md w-full mx-4" style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.08)"}}>
            <h3 className="text-lg font-bold mb-4 text-white">Sincronizare: {showSyncModal.name}</h3>

            {syncing && (
              <div className="rounded-xl p-3 mb-4" style={{background:"rgba(99,102,241,0.1)",border:"1px solid rgba(99,102,241,0.2)"}}>
                <div className="flex justify-between text-xs mb-2" style={{color:"#a5b4fc"}}>
                  <span>{syncProgress.step || "Se sincronizează..."}</span>
                  <span>{syncProgress.current}/{syncProgress.total_posts}</span>
                </div>
                <div className="w-full rounded-full h-1.5" style={{background:"rgba(255,255,255,0.06)"}}>
                  <div className="h-1.5 rounded-full transition-all" style={{
                    width: syncProgress.total_posts > 0
                      ? `${Math.round((syncProgress.current / syncProgress.total_posts) * 100)}%`
                      : "5%",
                    background:"linear-gradient(135deg,#6366f1,#8b5cf6)"
                  }}></div>
                </div>
              </div>
            )}

            {syncResult && (
              <div className="rounded-xl p-3 mb-4 text-sm"
                style={syncResult.error
                  ? {background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.2)",color:"#fca5a5"}
                  : {background:"rgba(34,197,94,0.1)",border:"1px solid rgba(34,197,94,0.2)",color:"#86efac"}}>
                {syncResult.error || `✓ Postări: ${syncResult.posts || 0} | Reacții: ${syncResult.reactions || 0} | Comentarii: ${syncResult.comments || 0}`}
              </div>
            )}

            <div className="space-y-4 mb-4">
              <div>
                <label className="text-xs mb-2 block" style={{color:"rgba(255,255,255,0.4)"}}>Număr postări</label>
                <div className="flex gap-2">
                  {[25, 50, 100].map(n => (
                    <button key={n} onClick={() => setSyncOptions(prev => ({...prev, limit: n}))}
                      className="flex-1 py-2 rounded-xl text-sm font-medium transition-all"
                      style={syncOptions.limit === n ? btnPrimary : btnGray}>
                      {n}
                    </button>
                  ))}
                  <input type="number" min="1" max="1000" placeholder="Alt nr"
                    className="w-24 rounded-xl px-3 py-2 text-sm text-center"
                    style={{...inputStyle, color:"white"}}
                    onFocus={e => e.target.select()}
                    onChange={e => {
                      const val = parseInt(e.target.value);
                      if (val > 0) setSyncOptions(prev => ({...prev, limit: val}));
                    }} />
                </div>
              </div>
              <div>
                <label className="text-xs mb-2 block" style={{color:"rgba(255,255,255,0.4)"}}>Ce să aducă</label>
                <div className="space-y-2">
                  {[
                    {key:"fetch_posts", label:"📝 Postări"},
                    {key:"fetch_reactions", label:"👍 Reacții"},
                    {key:"fetch_comments", label:"💬 Comentarii"},
                  ].map(opt => (
                    <label key={opt.key} className="flex items-center gap-3 p-2.5 rounded-xl cursor-pointer"
                      style={syncOptions[opt.key]
                        ? {background:"rgba(99,102,241,0.15)",border:"1px solid rgba(99,102,241,0.35)"}
                        : {background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.07)"}}>
                      <input type="checkbox" checked={syncOptions[opt.key]}
                        onChange={() => setSyncOptions(prev => ({...prev, [opt.key]: !prev[opt.key]}))}
                        className="accent-indigo-500" />
                      <span className="text-sm text-white">{opt.label}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="flex gap-3">
              <button onClick={() => syncPage(showSyncModal.id)} disabled={syncing}
                className="flex-1 py-2 rounded-xl text-sm font-semibold disabled:opacity-40"
                style={btnPrimary}>
                {syncing ? "Se sincronizează..." : "Sincronizează"}
              </button>
              <button onClick={closeSyncModal}
                className="flex-1 py-2 rounded-xl text-sm font-medium"
                style={btnGray}>
                Închide
              </button>
            </div>
          </div>
        </div>
      )}

      {showSyncAccountModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50" style={{background:"rgba(0,0,0,0.8)"}}>
          <div className="rounded-2xl p-6 max-w-md w-full mx-4" style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.08)"}}>
            <h3 className="text-lg font-bold mb-4 text-white">Sincronizare cont: {showSyncAccountModal.name}</h3>

            {syncingAccount && (
              <div className="rounded-xl p-3 mb-4" style={{background:"rgba(99,102,241,0.1)",border:"1px solid rgba(99,102,241,0.2)"}}>
                <div className="flex justify-between text-xs mb-2" style={{color:"#a5b4fc"}}>
                  <span>{syncAccountProgress.step || "Se sincronizează..."}</span>
                  <span>{syncAccountProgress.current_page}/{syncAccountProgress.total_pages} pagini</span>
                </div>
                <div className="w-full rounded-full h-1.5" style={{background:"rgba(255,255,255,0.06)"}}>
                  <div className="h-1.5 rounded-full transition-all" style={{
                    width: syncAccountProgress.total_pages > 0
                      ? `${Math.round((syncAccountProgress.current_page / syncAccountProgress.total_pages) * 100)}%`
                      : "5%",
                    background:"linear-gradient(135deg,#6366f1,#8b5cf6)"
                  }}></div>
                </div>
                {syncAccountProgress.page_name && (
                  <p className="text-xs mt-1" style={{color:"rgba(255,255,255,0.3)"}}>{syncAccountProgress.page_name}</p>
                )}
              </div>
            )}

            {syncAccountResult && (
              <div className="rounded-xl p-3 mb-4 text-sm"
                style={syncAccountResult.error
                  ? {background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.2)",color:"#fca5a5"}
                  : {background:"rgba(34,197,94,0.1)",border:"1px solid rgba(34,197,94,0.2)",color:"#86efac"}}>
                {syncAccountResult.error || `✓ Sincronizate ${syncAccountResult.pages} pagini!`}
              </div>
            )}

            <div className="space-y-4 mb-4">
              <div>
                <label className="text-xs mb-2 block" style={{color:"rgba(255,255,255,0.4)"}}>Număr postări per pagină</label>
                <div className="flex gap-2">
                  {[25, 50, 100].map(n => (
                    <button key={n} onClick={() => setSyncOptions(prev => ({...prev, limit: n}))}
                      className="flex-1 py-2 rounded-xl text-sm font-medium transition-all"
                      style={syncOptions.limit === n ? btnPrimary : btnGray}>
                      {n}
                    </button>
                  ))}
                  <input type="number" min="1" max="1000" placeholder="Alt nr"
                    className="w-24 rounded-xl px-3 py-2 text-sm text-center"
                    style={{...inputStyle, color:"white"}}
                    onFocus={e => e.target.select()}
                    onChange={e => {
                      const val = parseInt(e.target.value);
                      if (val > 0) setSyncOptions(prev => ({...prev, limit: val}));
                    }} />
                </div>
              </div>
              <div>
                <label className="text-xs mb-2 block" style={{color:"rgba(255,255,255,0.4)"}}>Ce să aducă</label>
                <div className="space-y-2">
                  {[
                    {key:"fetch_posts", label:"📝 Postări"},
                    {key:"fetch_reactions", label:"👍 Reacții"},
                    {key:"fetch_comments", label:"💬 Comentarii"},
                  ].map(opt => (
                    <label key={opt.key} className="flex items-center gap-3 p-2.5 rounded-xl cursor-pointer"
                      style={syncOptions[opt.key]
                        ? {background:"rgba(99,102,241,0.15)",border:"1px solid rgba(99,102,241,0.35)"}
                        : {background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.07)"}}>
                      <input type="checkbox" checked={syncOptions[opt.key]}
                        onChange={() => setSyncOptions(prev => ({...prev, [opt.key]: !prev[opt.key]}))}
                        className="accent-indigo-500" />
                      <span className="text-sm text-white">{opt.label}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>

            <div className="flex gap-3">
              <button onClick={() => syncAccount(showSyncAccountModal.id)} disabled={syncingAccount}
                className="flex-1 py-2 rounded-xl text-sm font-semibold disabled:opacity-40"
                style={btnPrimary}>
                {syncingAccount ? "Se sincronizează..." : `Sincronizează toate (${showSyncAccountModal.page_count} pagini)`}
              </button>
              <button onClick={closeSyncAccountModal}
                className="flex-1 py-2 rounded-xl text-sm font-medium"
                style={btnGray}>
                Închide
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="mb-6">
        <h2 className="text-2xl font-bold text-white">Configurare</h2>
        <p className="text-sm mt-0.5" style={{color:"rgba(255,255,255,0.35)"}}>Conturi, pagini si domenii</p>
      </div>

      {message && (
        <div className="rounded-xl p-3 mb-4 text-sm" style={message.includes("Eroare")
          ? {background:"rgba(239,68,68,0.1)", border:"1px solid rgba(239,68,68,0.2)", color:"#fca5a5"}
          : {background:"rgba(34,197,94,0.1)", border:"1px solid rgba(34,197,94,0.2)", color:"#86efac"}}>
          {message}
        </div>
      )}

      {/* Mobil: 2 randuri x 3, Desktop: 1 rand */}
      <div className="mb-6 block md:hidden">
        <div className="grid grid-cols-3 gap-1.5">
          {sections.map(s => (
            <button key={s.id} onClick={() => setActiveSection(s.id)}
              className="px-2 py-2.5 rounded-xl text-xs font-medium transition-all flex flex-col items-center gap-1"
              style={activeSection === s.id ? btnPrimary : btnGray}>
              <span className="text-base">{s.icon}</span>
              <span className="leading-tight text-center">{s.label}</span>
            </button>
          ))}
        </div>
      </div>
      <div className="hidden md:flex gap-2 mb-6">
        {sections.map(s => (
          <button key={s.id} onClick={() => setActiveSection(s.id)}
            className="px-4 py-2 rounded-xl text-sm font-medium transition-all"
            style={activeSection === s.id ? btnPrimary : btnGray}>
            {s.icon} {s.label}
          </button>
        ))}
      </div>

      {activeSection === "accounts" && (
        <div>
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold text-white">Conturi Facebook</h3>
            <button onClick={() => setShowAddAccount(!showAddAccount)}
              className="px-4 py-2 rounded-xl text-sm font-medium" style={btnPrimary}>
              + Adauga cont
            </button>
          </div>
          {showAddAccount && (
            <div className="rounded-2xl p-6 mb-4" style={card}>
              <h4 className="font-semibold mb-4 text-white">Cont nou</h4>
              <div className="space-y-3">
                <div>
                  <label className="text-xs mb-1 block" style={{color:"rgba(255,255,255,0.4)"}}>Nume cont</label>
                  <input className="w-full rounded-xl px-3 py-2.5 text-sm" style={inputStyle}
                    placeholder="Ex: Virgil Popescu"
                    value={newAccount.name} onChange={e => setNewAccount({...newAccount, name: e.target.value})} />
                </div>
                <div>
                  <label className="text-xs mb-1 block" style={{color:"rgba(255,255,255,0.4)"}}>User Token</label>
                  <textarea className="w-full rounded-xl px-3 py-2.5 text-sm font-mono resize-none" style={inputStyle}
                    placeholder="EAAXg94g..." rows={3}
                    value={newAccount.user_token} onChange={e => setNewAccount({...newAccount, user_token: e.target.value})} />
                </div>
                <p className="text-xs" style={{color:"rgba(255,255,255,0.25)"}}>Tokenul va fi convertit automat in long-lived (60 zile).</p>
              </div>
              <div className="flex gap-2 mt-4">
                <button onClick={addAccount} disabled={loading || !newAccount.name || !newAccount.user_token}
                  className="px-4 py-2 rounded-xl text-sm font-medium disabled:opacity-50" style={btnPrimary}>
                  {loading ? "Se importa..." : "Adauga si importa pagini"}
                </button>
                <button onClick={() => setShowAddAccount(false)}
                  className="px-4 py-2 rounded-xl text-sm font-medium" style={btnGray}>Anuleaza</button>
              </div>
            </div>
          )}
          {accounts.length === 0 ? (
            <div className="text-center py-12 text-sm" style={{color:"rgba(255,255,255,0.25)"}}>Niciun cont adaugat.</div>
          ) : (
            <div className="space-y-3">
              {accounts.map(account => (
                <div key={account.id} className="rounded-2xl p-5" style={card}>
                  <div className="flex justify-between items-center">
                    <div>
                      <div className="flex items-center gap-2 mb-1">
                        <h4 className="font-semibold text-white">{account.name}</h4>
                        <ExpiryBadge expiresAt={account.token_expires_at} />
                      </div>
                      <p className="text-xs" style={{color:"rgba(255,255,255,0.3)"}}>
                        {account.page_count} pagini
                        {account.token_expires_at && <span className="ml-2">· Expira: {new Date(account.token_expires_at).toLocaleDateString('ro-RO')}</span>}
                      </p>
                    </div>
                    <div className="flex gap-1.5 flex-wrap justify-end">
                      <button onClick={() => { setShowSyncAccountModal(account); setSyncAccountResult(null); }}
                        className="px-2 py-1.5 rounded-xl text-xs font-medium"
                        style={{background:"rgba(99,102,241,0.15)",border:"1px solid rgba(99,102,241,0.3)",color:"#a5b4fc"}}>
                        🔄 Sync
                      </button>
                      <button onClick={() => setRefreshingAccount(refreshingAccount === account.id ? null : account.id)}
                        className="px-2 py-1.5 rounded-xl text-xs font-medium" style={btnYellow}>
                        🔑 Token
                      </button>
                      <button onClick={() => setShowCookiesModal(account)}
                        className="px-2 py-1.5 rounded-xl text-xs font-medium"
                        style={{
                          background: account.playwright_enabled ? "rgba(168,85,247,0.15)" : "rgba(156,163,175,0.1)",
                          border: "1px solid " + (account.playwright_enabled ? "rgba(168,85,247,0.4)" : "rgba(156,163,175,0.2)"),
                          color: account.playwright_enabled ? "#d8b4fe" : "#9ca3af"
                        }}>
                        🎭 {account.playwright_enabled ? "Playwright" : "Activează"}
                      </button>
                      <button onClick={() => setShowDeleteAccount(account)}
                        className="px-2 py-1.5 rounded-xl text-xs font-medium" style={btnRed}>
                        🗑
                      </button>
                    </div>
                  </div>
                  {refreshingAccount === account.id && (
                    <div className="mt-4 pt-4" style={{borderTop:"1px solid rgba(255,255,255,0.06)"}}>
                      <label className="text-xs mb-2 block" style={{color:"rgba(255,255,255,0.4)"}}>User Token nou</label>
                      <textarea className="w-full rounded-xl px-3 py-2.5 text-sm font-mono resize-none mb-3" style={inputStyle}
                        placeholder="EAAXg94g..." rows={2}
                        value={refreshToken} onChange={e => setRefreshToken(e.target.value)} />
                      <div className="flex gap-2">
                        <button onClick={() => refreshAccountToken(account.id)}
                          disabled={loading || !refreshToken}
                          className="px-3 py-1.5 rounded-xl text-xs font-medium disabled:opacity-50" style={btnYellow}>
                          {loading ? "Se reinnoieste..." : "Reinnoieste"}
                        </button>
                        <button onClick={() => { setRefreshingAccount(null); setRefreshToken(""); }}
                          className="px-3 py-1.5 rounded-xl text-xs font-medium" style={btnGray}>Anuleaza</button>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {activeSection === "pages" && (
        <div>
          <h3 className="text-lg font-semibold mb-4 text-white">Pagini Facebook ({pages.length})</h3>
          {pages.length === 0 ? (
            <div className="text-center py-12 text-sm" style={{color:"rgba(255,255,255,0.25)"}}>Nicio pagina.</div>
          ) : (
            <div className="space-y-6">
              {accounts.map(account => {
                const accountPages = pages.filter(p => Number(p.account_id) === Number(account.id));
                if (accountPages.length === 0) return null;
                return (
                  <div key={account.id}>
                    <div className="flex items-center gap-2 mb-3">
                      <h4 className="text-sm font-semibold" style={{color:"rgba(255,255,255,0.5)"}}>{account.name}</h4>
                      <span className="text-xs px-2 py-0.5 rounded-full" style={{background:"rgba(255,255,255,0.05)",color:"rgba(255,255,255,0.3)"}}>
                        {accountPages.length} pagini
                      </span>
                    </div>
                    <div className="space-y-3">
                      {accountPages.map(page => (
                        <PageCard key={page.id} page={page}
                          onSync={handleOpenSyncModal}
                          onToggle={togglePage}
                          onUpdate={updatePage}
                          onOpenContext={p => setContextModal({...p, value: p.context || ""})}
                          onToggleAutopilot={toggleAutopilotReplies} />
                      ))}
                    </div>
                  </div>
                );
              })}
              {pages.filter(p => !p.account_id).length > 0 && (
                <div>
                  <h4 className="text-sm font-semibold mb-3" style={{color:"rgba(234,179,8,0.7)"}}>Fara cont asociat</h4>
                  <div className="space-y-3">
                    {pages.filter(p => !p.account_id).map(page => (
                      <PageCard key={page.id} page={page}
                        onSync={handleOpenSyncModal}
                        onToggle={togglePage}
                        onUpdate={updatePage}
                        onOpenContext={p => setContextModal({...p, value: p.context || ""})}
                        onToggleAutopilot={toggleAutopilotReplies} />
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {activeSection === "playwright" && (
        <div>
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold text-white">🎭 Identități Playwright</h3>
            <button onClick={fetchPwIdentities}
              className="px-3 py-1.5 rounded-xl text-xs font-medium" style={btnGray}>
              🔄 Refresh
            </button>
          </div>
          
          <div className="rounded-2xl p-4 mb-4" style={{background:"rgba(99,102,241,0.08)",border:"1px solid rgba(99,102,241,0.2)"}}>
            <p className="text-xs leading-relaxed" style={{color:"rgba(255,255,255,0.7)"}}>
              Playwright permite acțiuni pe Facebook (Like, Comentariu, Share) folosind cookies salvate. 
              Activează din lista de conturi (tab Conturi Facebook → buton 🎭). 
              Cookies se reîmprospătează automat la fiecare 6h. Când expiră, re-uploadezi din Cookie-Editor de pe Mac.
            </p>
          </div>
          
          {pwIdentities.length === 0 ? (
            <div className="text-center py-12 text-sm" style={{color:"rgba(255,255,255,0.25)"}}>
              Niciun cont activat pentru Playwright. Mergi la <strong>Conturi Facebook</strong> și apasă butonul 🎭 pe contul dorit.
            </div>
          ) : (
            <div className="space-y-3">
              {pwIdentities.map(ident => {
                const statusColor = 
                  ident.health_status === 'active' ? { bg: 'rgba(34,197,94,0.15)', border: 'rgba(34,197,94,0.3)', text: '#86efac' } :
                  ident.health_status === 'expiring' ? { bg: 'rgba(234,179,8,0.15)', border: 'rgba(234,179,8,0.3)', text: '#fde047' } :
                  ident.health_status === 'invalidated' ? { bg: 'rgba(239,68,68,0.15)', border: 'rgba(239,68,68,0.3)', text: '#fca5a5' } :
                  { bg: 'rgba(156,163,175,0.15)', border: 'rgba(156,163,175,0.3)', text: '#d1d5db' };
                const statusLabel = 
                  ident.health_status === 'active' ? '🟢 Activă' :
                  ident.health_status === 'expiring' ? '🟡 Expiră curând' :
                  ident.health_status === 'invalidated' ? '🔴 Invalidă' :
                  '⚪ Necunoscut';
                const days = ident.days_until_expiry;
                const isLoading = pwLoading[ident.id];
                
                return (
                  <div key={ident.id} className="rounded-2xl p-5" style={card}>
                    <div className="flex justify-between items-start mb-3">
                      <div>
                        <div className="flex items-center gap-2 mb-1">
                          <h4 className="font-semibold text-white">{ident.name}</h4>
                          <span className="px-2 py-0.5 rounded-lg text-xs" style={{
                            background: ident.type === 'account' ? 'rgba(99,102,241,0.15)' : 'rgba(168,85,247,0.15)',
                            border: '1px solid ' + (ident.type === 'account' ? 'rgba(99,102,241,0.3)' : 'rgba(168,85,247,0.3)'),
                            color: ident.type === 'account' ? '#a5b4fc' : '#d8b4fe'
                          }}>
                            {ident.type === 'account' ? '👤 Cont' : '📄 Pagină'}
                          </span>
                          <span className="px-2 py-0.5 rounded-lg text-xs" style={{
                            background: statusColor.bg, border: '1px solid ' + statusColor.border, color: statusColor.text
                          }}>
                            {statusLabel}
                          </span>
                        </div>
                        <div className="flex gap-4 text-xs mt-2" style={{color:"rgba(255,255,255,0.4)"}}>
                          <span>🍪 {ident.cookies_count || 0} cookies</span>
                          <span>📅 {days !== null && days !== undefined ? `${days} zile până la expirare` : 'Necunoscut'}</span>
                          <span>📊 {ident.actions_today || 0}/{ident.daily_limit} acțiuni azi</span>
                        </div>
                        {ident.last_touch_at && (
                          <div className="text-xs mt-1" style={{color:"rgba(255,255,255,0.3)"}}>
                            Ultimul touch: {new Date(ident.last_touch_at).toLocaleString('ro-RO')}
                          </div>
                        )}
                      </div>
                      <div className="flex gap-1.5 flex-wrap justify-end">
                        <button onClick={() => touchPwIdentity(ident.id)}
                          disabled={isLoading}
                          className="px-2 py-1.5 rounded-xl text-xs font-medium disabled:opacity-50"
                          style={btnPrimary}>
                          {isLoading === 'touch' ? '⏳' : '🔄'} Touch
                        </button>
                        <button onClick={() => healthCheckPwIdentity(ident.id)}
                          disabled={isLoading}
                          className="px-2 py-1.5 rounded-xl text-xs font-medium disabled:opacity-50"
                          style={{background:"rgba(34,197,94,0.15)",border:"1px solid rgba(34,197,94,0.3)",color:"#86efac"}}>
                          {isLoading === 'health' ? '⏳' : '🏥'} Health
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}
      
      {activeSection === "domains" && (
        <div>
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold text-white">Domenii Campanii</h3>
            <button onClick={() => setShowAddDomain(!showAddDomain)}
              className="px-4 py-2 rounded-xl text-sm font-medium" style={btnPrimary}>
              + Adauga domeniu
            </button>
          </div>
          {showAddDomain && (
            <div className="rounded-2xl p-6 mb-4" style={card}>
              <h4 className="font-semibold mb-4 text-white">Domeniu nou</h4>
              <div className="space-y-3">
                <input className="w-full rounded-xl px-3 py-2.5 text-sm" style={inputStyle}
                  placeholder="Nume domeniu (ex: Infrastructura)"
                  value={newDomain.name} onChange={e => setNewDomain({...newDomain, name: e.target.value})} />
                <input className="w-full rounded-xl px-3 py-2.5 text-sm" style={inputStyle}
                  placeholder="Descriere (optional)"
                  value={newDomain.description} onChange={e => setNewDomain({...newDomain, description: e.target.value})} />
                <div className="flex items-center gap-3">
                  <label className="text-xs" style={{color:"rgba(255,255,255,0.4)"}}>Culoare:</label>
                  <input type="color" value={newDomain.color}
                    onChange={e => setNewDomain({...newDomain, color: e.target.value})}
                    className="w-10 h-8 rounded-lg cursor-pointer border-0 bg-transparent" />
                  <span className="text-xs font-mono" style={{color:"rgba(255,255,255,0.35)"}}>{newDomain.color}</span>
                </div>
              </div>
              <div className="flex gap-2 mt-4">
                <button onClick={addDomain} disabled={!newDomain.name}
                  className="px-4 py-2 rounded-xl text-sm font-medium disabled:opacity-50" style={btnPrimary}>Adauga</button>
                <button onClick={() => setShowAddDomain(false)}
                  className="px-4 py-2 rounded-xl text-sm font-medium" style={btnGray}>Anuleaza</button>
              </div>
            </div>
          )}
          {domains.length === 0 ? (
            <div className="text-center py-12 text-sm" style={{color:"rgba(255,255,255,0.25)"}}>Niciun domeniu.</div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              {domains.map(domain => (
                <div key={domain.id} className="rounded-xl p-4" style={card}>
                  <div className="flex justify-between items-start mb-2">
                    <div className="flex items-center gap-2">
                      <div className="w-3 h-3 rounded-full flex-shrink-0" style={{backgroundColor: domain.color}}></div>
                      <h4 className="font-semibold text-sm text-white">{domain.name}</h4>
                    </div>
                    <button onClick={() => setShowDeleteDomain(domain)}
                      className="text-xs px-2 py-1 rounded-lg" style={{color:"rgba(239,68,68,0.6)"}}>Sterge</button>
                  </div>
                  {domain.description && <p className="text-xs mb-1" style={{color:"rgba(255,255,255,0.4)"}}>{domain.description}</p>}
                  <p className="text-xs" style={{color:"rgba(255,255,255,0.2)"}}>{domain.campaign_count} campanii</p>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {activeSection === "ai" && (
        <div className="space-y-4">
          <h3 className="text-lg font-semibold mb-4 text-white">Setări AI</h3>
          <div className="flex gap-1 mb-2 p-1 rounded-xl" style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(255,255,255,0.06)"}}>
            {[
              {id:"modele", label:"🤖 Modele"},
              {id:"postari", label:"📄 Postări"},
              {id:"comentarii", label:"💬 Comentarii"},
            ].map(t => (
              <button key={t.id} onClick={() => setAiSubTab(t.id)}
                className="flex-1 px-2 py-2 rounded-lg text-xs font-medium transition-all"
                style={aiSubTab === t.id ? btnPrimary : {color:"rgba(255,255,255,0.4)"}}>
                {t.label}
              </button>
            ))}
          </div>

          {aiSubTab === "modele" && (
            <div className="space-y-4">
              <div className="rounded-2xl p-5" style={card}>
                <h4 className="font-semibold text-white mb-4">🔑 API Keys</h4>
                <div className="space-y-4">
                  <div>
                    <label className="text-xs mb-1 block" style={{color:"rgba(255,255,255,0.4)"}}>Anthropic API Key</label>
                    <div className="flex flex-col md:flex-row gap-2">
                      <input className="flex-1 rounded-xl px-3 py-2.5 text-sm font-mono" style={inputStyle}
                        type="password" placeholder="sk-ant-..."
                        value={aiSettings.anthropic_api_key || ""}
                        onChange={e => setAiSettings(prev => ({...prev, anthropic_api_key: e.target.value}))} />
                      <button onClick={async () => {
                        await axios.put(`${API}/settings/anthropic_api_key`, {value: aiSettings.anthropic_api_key});
                        await axios.post(`${API}/settings/update-env`, {key: "ANTHROPIC_API_KEY", value: aiSettings.anthropic_api_key});
                        setMessage("Anthropic API Key salvat!");
                      }} className="px-3 py-2 rounded-xl text-xs font-medium" style={btnPrimary}>Salvează</button>
                    </div>
                  </div>
                  <div>
                    <label className="text-xs mb-1 block" style={{color:"rgba(255,255,255,0.4)"}}>OpenAI API Key</label>
                    <div className="flex flex-col md:flex-row gap-2">
                      <input className="flex-1 rounded-xl px-3 py-2.5 text-sm font-mono" style={inputStyle}
                        type="password" placeholder="sk-proj-..."
                        value={aiSettings.openai_api_key || ""}
                        onChange={e => setAiSettings(prev => ({...prev, openai_api_key: e.target.value}))} />
                      <button onClick={async () => {
                        await axios.put(`${API}/settings/openai_api_key`, {value: aiSettings.openai_api_key});
                        setMessage("OpenAI API Key salvat!");
                      }} className="px-3 py-2 rounded-xl text-xs font-medium" style={btnPrimary}>Salvează</button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="rounded-2xl p-5" style={card}>
                <h4 className="font-semibold text-white mb-4">🤖 Modele AI</h4>
                <div className="space-y-4">
                  <div>
                    <label className="text-xs mb-2 block" style={{color:"rgba(255,255,255,0.4)"}}>🔍 Clasificare Comentarii</label>
                    <div className="flex gap-2">
                      <select className="flex-1 rounded-xl px-3 py-2.5 text-sm" style={inputStyle}
                        value={aiSettings.classify_provider}
                        onChange={e => {
                          const provider = e.target.value;
                          const defaultModel = provider === 'openai' ? 'gpt-4o' : 'claude-sonnet-4-6';
                          setAiSettings(prev => ({...prev, classify_provider: provider, classify_model: defaultModel}));
                        }}>
                        <option style={{color:"black"}} value="anthropic">Anthropic (Claude)</option>
                        <option style={{color:"black"}} value="openai">OpenAI (ChatGPT)</option>
                      </select>
                      <select className="flex-1 rounded-xl px-3 py-2.5 text-sm" style={inputStyle}
                        value={aiSettings.classify_model}
                        onChange={e => setAiSettings(prev => ({...prev, classify_model: e.target.value}))}>
                        {aiSettings.classify_provider === "anthropic" ? (
                          <>
                            <option style={{color:"black"}} value="claude-sonnet-4-6">Claude Sonnet 4.6</option>
                            <option style={{color:"black"}} value="claude-haiku-4-5-20251001">Claude Haiku 4.5</option>
                            <option style={{color:"black"}} value="claude-opus-4-6">Claude Opus 4.6</option>
                          </>
                        ) : (
                          <>
                            <option style={{color:"black"}} value="gpt-4o">GPT-4o</option>
                            <option style={{color:"black"}} value="gpt-4o-mini">GPT-4o Mini</option>
                            <option style={{color:"black"}} value="gpt-4-turbo">GPT-4 Turbo</option>
                          </>
                        )}
                      </select>
                      <button onClick={async () => {
                        await axios.put(`${API}/settings/classify_provider`, {value: aiSettings.classify_provider});
                        await axios.put(`${API}/settings/classify_model`, {value: aiSettings.classify_model});
                        setMessage("Model clasificare salvat!");
                      }} className="px-3 py-2 rounded-xl text-xs font-medium flex-shrink-0" style={btnPrimary}>Salvează</button>
                    </div>
                  </div>
                  <div>
                    <label className="text-xs mb-2 block" style={{color:"rgba(255,255,255,0.4)"}}>✍️ Generare Postări & Reply-uri</label>
                    <div className="flex gap-2">
                      <select className="flex-1 rounded-xl px-3 py-2.5 text-sm" style={inputStyle}
                        value={aiSettings.generate_provider}
                        onChange={e => {
                          const provider = e.target.value;
                          const defaultModel = provider === 'openai' ? 'gpt-4o-mini' : 'claude-haiku-4-5-20251001';
                          setAiSettings(prev => ({...prev, generate_provider: provider, generate_model: defaultModel}));
                        }}>
                        <option style={{color:"black"}} value="anthropic">Anthropic (Claude)</option>
                        <option style={{color:"black"}} value="openai">OpenAI (ChatGPT)</option>
                      </select>
                      <select className="flex-1 rounded-xl px-3 py-2.5 text-sm" style={inputStyle}
                        value={aiSettings.generate_model}
                        onChange={e => setAiSettings(prev => ({...prev, generate_model: e.target.value}))}>
                        {aiSettings.generate_provider === "anthropic" ? (
                          <>
                            <option style={{color:"black"}} value="claude-haiku-4-5-20251001">Claude Haiku 4.5</option>
                            <option style={{color:"black"}} value="claude-sonnet-4-6">Claude Sonnet 4.6</option>
                            <option style={{color:"black"}} value="claude-opus-4-6">Claude Opus 4.6</option>
                          </>
                        ) : (
                          <>
                            <option style={{color:"black"}} value="gpt-4o-mini">GPT-4o Mini</option>
                            <option style={{color:"black"}} value="gpt-4o">GPT-4o</option>
                            <option style={{color:"black"}} value="gpt-4-turbo">GPT-4 Turbo</option>
                          </>
                        )}
                      </select>
                      <button onClick={async () => {
                        await axios.put(`${API}/settings/generate_provider`, {value: aiSettings.generate_provider});
                        await axios.put(`${API}/settings/generate_model`, {value: aiSettings.generate_model});
                        setMessage("Model generare salvat!");
                      }} className="px-3 py-2 rounded-xl text-xs font-medium flex-shrink-0" style={btnPrimary}>Salvează</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {aiSubTab === "postari" && (
            <div className="space-y-4">
              <div className="rounded-2xl p-5" style={card}>
                <h4 className="font-semibold text-white mb-2">📄 Instrucțiuni Generale Postare</h4>
                <p className="text-xs mb-4" style={{color:"rgba(255,255,255,0.4)"}}>Instrucțiuni suplimentare pentru AI. Ex: evită anumite cuvinte, stil specific etc.</p>
                <textarea className="w-full rounded-xl px-3 py-2.5 text-sm resize-none mb-3" style={inputStyle} rows={4}
                  placeholder="Ex: Folosește un limbaj direct și convingător. Evită clișeele politice..."
                  value={promptSettings.prompt_post || "Scrie postarea în limba română. Folosește un limbaj direct, convingător și adaptat publicului de pe Facebook. Evită clișeele politice. Include un call-to-action la final."}
                  onChange={e => setPromptSettings(prev => ({...prev, prompt_post: e.target.value}))} />
                <button onClick={async () => {
                  await axios.put(`${API}/settings/prompt_post`, {value: promptSettings.prompt_post || ""});
                  setMessage("Instrucțiuni postare salvate!");
                }} className="px-4 py-2 rounded-xl text-sm font-medium" style={btnPrimary}>Salvează</button>
              </div>
              <div className="rounded-2xl p-5" style={card}>
                <h4 className="font-semibold text-white mb-2">📏 Lungime Postări AI</h4>
                <p className="text-xs mb-4" style={{color:"rgba(255,255,255,0.4)"}}>Setează lungimea implicită pentru postările generate de AI.</p>
                <div className="space-y-3 mb-4">
                  {[
                    {value:"scurta", label:"Scurtă", desc:"1-2 propoziții, ~50 cuvinte"},
                    {value:"medie", label:"Medie", desc:"3-5 propoziții, ~150 cuvinte"},
                    {value:"lunga", label:"Lungă", desc:"6-10 propoziții, ~400 cuvinte"},
                  ].map(opt => (
                    <div key={opt.value} onClick={() => setPromptSettings(prev => ({...prev, post_length: opt.value}))}
                      className="flex items-center gap-3 rounded-xl px-4 py-3 cursor-pointer"
                      style={promptSettings.post_length === opt.value
                        ? {background:"rgba(99,102,241,0.15)",border:"1px solid rgba(99,102,241,0.4)"}
                        : {background:"rgba(255,255,255,0.02)",border:"1px solid rgba(255,255,255,0.06)"}}>
                      <div className="w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0"
                        style={{borderColor: promptSettings.post_length === opt.value ? "#6366f1" : "rgba(255,255,255,0.2)"}}>
                        {promptSettings.post_length === opt.value && <div className="w-2 h-2 rounded-full" style={{background:"#6366f1"}}></div>}
                      </div>
                      <div>
                        <p className="text-sm font-medium text-white">{opt.label}</p>
                        <p className="text-xs" style={{color:"rgba(255,255,255,0.4)"}}>{opt.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
                <button onClick={async () => {
                  await axios.put(`${API}/settings/post_length`, {value: promptSettings.post_length});
                  setMessage("Lungime postare salvată!");
                }} className="px-4 py-2 rounded-xl text-sm font-medium" style={btnPrimary}>Salvează</button>
              </div>
            </div>
          )}

          {aiSubTab === "comentarii" && (
            <div className="rounded-2xl p-5" style={card}>
              <h4 className="font-semibold text-white mb-2">💬 Prompturi Răspuns Comentarii</h4>
              <p className="text-xs mb-4" style={{color:"rgba(255,255,255,0.4)"}}>Personalizează instrucțiunile AI pentru fiecare tip de comentariu.</p>
              <div className="space-y-4">
                {[
                  {key:"prompt_sustinator", label:"✅ Susținător", color:"#86efac"},
                  {key:"prompt_critic", label:"⚠️ Critic", color:"#fde047"},
                  {key:"prompt_troll", label:"🚫 Trol", color:"#fca5a5"},
                  {key:"prompt_intrebare", label:"❓ Întrebare", color:"#a5b4fc"},
                  {key:"prompt_neutru", label:"⬜ Neutru", color:"rgba(255,255,255,0.4)"},
                ].map(({key, label, color}) => (
                  <div key={key}>
                    <div className="flex justify-between items-center mb-1">
                      <label className="text-xs font-medium" style={{color}}>{label}</label>
                      <button onClick={() => setPromptModal({key, label, color, value: promptSettings[key] || ""})}
                        className="text-xs px-2 py-0.5 rounded-lg"
                        style={{background:"rgba(99,102,241,0.15)",color:"#a5b4fc",border:"1px solid rgba(99,102,241,0.3)"}}>
                        ↗ Extinde
                      </button>
                    </div>
                    <textarea className="w-full rounded-xl px-3 py-2.5 text-sm resize-none" style={inputStyle} rows={2}
                      value={promptSettings[key] || ""}
                      onChange={e => setPromptSettings(prev => ({...prev, [key]: e.target.value}))} />
                  </div>
                ))}
                <button onClick={async () => {
                  try {
                    await Promise.all([
                      axios.put(`${API}/settings/prompt_sustinator`, {value: promptSettings.prompt_sustinator || ""}),
                      axios.put(`${API}/settings/prompt_critic`, {value: promptSettings.prompt_critic || ""}),
                      axios.put(`${API}/settings/prompt_troll`, {value: promptSettings.prompt_troll || ""}),
                      axios.put(`${API}/settings/prompt_intrebare`, {value: promptSettings.prompt_intrebare || ""}),
                      axios.put(`${API}/settings/prompt_neutru`, {value: promptSettings.prompt_neutru || ""}),
                    ]);
                    setMessage("Prompturi salvate!");
                  } catch(e) { setMessage("Eroare!"); }
                }} className="px-4 py-2 rounded-xl text-sm font-medium" style={btnPrimary}>
                  Salvează prompturile
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      {activeSection === "prompts" && (
        <div className="space-y-6">
          <h3 className="text-lg font-semibold mb-4 text-white">📝 Prompturi AI</h3>

          <div className="rounded-2xl p-5" style={card}>
            <h4 className="font-semibold text-white mb-4">💬 Prompturi Răspuns Comentarii</h4>
            <p className="text-xs mb-4" style={{color:"rgba(255,255,255,0.4)"}}>Personalizează instrucțiunile AI pentru fiecare tip de comentariu. Lasă gol pentru instrucțiunile implicite.</p>
            <div className="space-y-4">
              {[
                {key:"prompt_sustinator", label:"✅ Susținător", placeholder:"Ex: Răspunde cu căldură, mulțumește-i și încurajează-l...", color:"#86efac"},
                {key:"prompt_critic", label:"⚠️ Critic", placeholder:"Ex: Răspunde ferm, contraargumentează, fii puțin agresiv dar argumentat...", color:"#fde047"},
                {key:"prompt_troll", label:"🚫 Trol", placeholder:"Ex: Răspunde agresiv și direct, contraatacă ferm, fii tăios...", color:"#fca5a5"},
                {key:"prompt_intrebare", label:"❓ Întrebare", placeholder:"Ex: Răspunde informativ, clar și direct la întrebare...", color:"#a5b4fc"},
                {key:"prompt_neutru", label:"⬜ Neutru", placeholder:"Ex: Răspunde scurt și prietenos...", color:"rgba(255,255,255,0.4)"},
              ].map(({key, label, placeholder, color}) => (
                <div key={key}>
                  <label className="text-xs mb-1 block font-medium" style={{color}}>{label}</label>
                  <textarea
                    className="w-full rounded-xl px-3 py-2.5 text-sm resize-none"
                    style={inputStyle}
                    rows={3}
                    placeholder={placeholder}
                    value={promptSettings[key]}
                    onChange={e => setPromptSettings(prev => ({...prev, [key]: e.target.value}))}
                  />
                </div>
              ))}
              <button onClick={async () => {
                try {
                  await Promise.all([
                    axios.put(`${API}/settings/prompt_sustinator`, {value: promptSettings.prompt_sustinator}),
                    axios.put(`${API}/settings/prompt_critic`, {value: promptSettings.prompt_critic}),
                    axios.put(`${API}/settings/prompt_troll`, {value: promptSettings.prompt_troll}),
                    axios.put(`${API}/settings/prompt_intrebare`, {value: promptSettings.prompt_intrebare}),
                    axios.put(`${API}/settings/prompt_neutru`, {value: promptSettings.prompt_neutru}),
                  ]);
                  setMessage("Prompturi salvate!");
                } catch(e) { setMessage("Eroare la salvare!"); }
              }} className="px-4 py-2 rounded-xl text-sm font-medium" style={btnPrimary}>
                Salvează prompturile
              </button>
            </div>
          </div>

          <div className="rounded-2xl p-5" style={card}>
            <h4 className="font-semibold text-white mb-2">📄 Lungime Postări AI</h4>
            <p className="text-xs mb-4" style={{color:"rgba(255,255,255,0.4)"}}>Setează lungimea implicită pentru postările generate de AI.</p>
            <div className="space-y-3 mb-4">
              {[
                {value:"scurta", label:"Scurtă", desc:"1-2 propoziții, ~50 cuvinte"},
                {value:"medie", label:"Medie", desc:"3-5 propoziții, ~150 cuvinte"},
                {value:"lunga", label:"Lungă", desc:"6-10 propoziții, ~400 cuvinte"},
              ].map(opt => (
                <div key={opt.value}
                  onClick={() => setPromptSettings(prev => ({...prev, post_length: opt.value}))}
                  className="flex items-center gap-3 rounded-xl px-4 py-3 cursor-pointer transition-all"
                  style={promptSettings.post_length === opt.value
                    ? {background:"rgba(99,102,241,0.15)", border:"1px solid rgba(99,102,241,0.4)"}
                    : {background:"rgba(255,255,255,0.02)", border:"1px solid rgba(255,255,255,0.06)"}}>
                  <div className="w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0"
                    style={{borderColor: promptSettings.post_length === opt.value ? "#6366f1" : "rgba(255,255,255,0.2)"}}>
                    {promptSettings.post_length === opt.value && (
                      <div className="w-2 h-2 rounded-full" style={{background:"#6366f1"}}></div>
                    )}
                  </div>
                  <div>
                    <p className="text-sm font-medium text-white">{opt.label}</p>
                    <p className="text-xs" style={{color:"rgba(255,255,255,0.4)"}}>{opt.desc}</p>
                  </div>
                </div>
              ))}
            </div>
            <button onClick={async () => {
              try {
                await axios.put(`${API}/settings/post_length`, {value: promptSettings.post_length});
                setMessage("Lungime postare salvată!");
              } catch(e) { setMessage("Eroare!"); }
            }} className="px-4 py-2 rounded-xl text-sm font-medium" style={btnPrimary}>
              Salvează
            </button>
          </div>
        </div>
      )}

      {activeSection === "sla" && (
        <div>
          <h3 className="text-lg font-semibold text-white mb-2">Alerte Timp Răspuns</h3>
          <p className="text-sm mb-6" style={{color:"rgba(255,255,255,0.4)"}}>
            Setează pragurile de timp după care comentariile nerezolvate din Inbox primesc alertă colorată.
          </p>

          {slaMessage && (
            <div className="rounded-xl p-3 mb-4 text-sm" style={slaMessage.includes("Eroare")
              ? {background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.2)",color:"#fca5a5"}
              : {background:"rgba(34,197,94,0.1)",border:"1px solid rgba(34,197,94,0.2)",color:"#86efac"}}>
              {slaMessage}
            </div>
          )}

          <div className="rounded-2xl p-5 space-y-5" style={card}>
            <div className="flex items-center gap-4">
              <div className="w-3 h-3 rounded-full flex-shrink-0" style={{background:"#fde047"}}></div>
              <div className="flex-1">
                <p className="text-sm font-medium text-white mb-1">Alertă galbenă după</p>
                <p className="text-xs mb-2" style={{color:"rgba(255,255,255,0.4)"}}>Comentariile mai vechi de acest timp primesc badge galben</p>
              </div>
              <div className="flex items-center gap-2">
                <input type="number" min="1" max="24"
                  className="w-20 rounded-xl px-3 py-2 text-sm text-center" style={inputStyle}
                  value={slaSettings.sla_yellow_hours}
                  onChange={e => setSlaSettings(prev => ({...prev, sla_yellow_hours: parseInt(e.target.value) || 1}))} />
                <span className="text-sm" style={{color:"rgba(255,255,255,0.4)"}}>ore</span>
              </div>
            </div>

            <div className="flex items-center gap-4">
              <div className="w-3 h-3 rounded-full flex-shrink-0" style={{background:"#fca5a5"}}></div>
              <div className="flex-1">
                <p className="text-sm font-medium text-white mb-1">Alertă roșie după</p>
                <p className="text-xs mb-2" style={{color:"rgba(255,255,255,0.4)"}}>Comentariile mai vechi de acest timp primesc badge roșu</p>
              </div>
              <div className="flex items-center gap-2">
                <input type="number" min="1" max="72"
                  className="w-20 rounded-xl px-3 py-2 text-sm text-center" style={inputStyle}
                  value={slaSettings.sla_red_hours}
                  onChange={e => setSlaSettings(prev => ({...prev, sla_red_hours: parseInt(e.target.value) || 3}))} />
                <span className="text-sm" style={{color:"rgba(255,255,255,0.4)"}}>ore</span>
              </div>
            </div>

            <div className="pt-2 border-t" style={{borderColor:"rgba(255,255,255,0.06)"}}>
              <h4 className="text-xs font-semibold mb-3" style={{color:"rgba(255,255,255,0.4)"}}>PREVIZUALIZARE</h4>
              <div className="flex gap-3 flex-wrap">
                <span className="text-xs px-3 py-1.5 rounded-full font-medium" style={{background:"rgba(34,197,94,0.15)",color:"#86efac"}}>
                  🟢 sub {slaSettings.sla_yellow_hours}h — ok
                </span>
                <span className="text-xs px-3 py-1.5 rounded-full font-medium" style={{background:"rgba(234,179,8,0.15)",color:"#fde047"}}>
                  🟡 {slaSettings.sla_yellow_hours}h - {slaSettings.sla_red_hours}h — atenție
                </span>
                <span className="text-xs px-3 py-1.5 rounded-full font-medium" style={{background:"rgba(239,68,68,0.15)",color:"#fca5a5"}}>
                  🔴 peste {slaSettings.sla_red_hours}h — depășit
                </span>
              </div>
            </div>

            <button onClick={saveSla} disabled={slaLoading}
              className="w-full py-2.5 rounded-xl text-sm font-medium disabled:opacity-50" style={btnPrimary}>
              {slaLoading ? "Se salvează..." : "Salvează setările"}
            </button>
          </div>
        </div>
      )}

      {activeSection === "whitelist" && (
        <div>
          <div className="flex justify-between items-center mb-4">
            <div>
              <h3 className="text-lg font-semibold text-white">⭐ Whitelist Susținători</h3>
              <p className="text-xs mt-0.5" style={{color:"rgba(255,255,255,0.35)"}}>Useri protejați — nu pot fi blocați, clasificați automat ca susținători</p>
            </div>
            <div className="flex gap-2 flex-wrap">
              <button onClick={() => setShowBulkImport(true)}
                className="px-4 py-2 rounded-xl text-sm font-medium" style={btnGray}>
                📥 Import lista
              </button>
              <button onClick={() => setShowAddWhitelist(!showAddWhitelist)}
                className="px-4 py-2 rounded-xl text-sm font-medium" style={btnPrimary}>
                + Adaugă user
              </button>
            </div>
          </div>

          {/* MODAL BULK IMPORT */}
          {showBulkImport && (
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{background:"rgba(0,0,0,0.7)"}} onClick={() => !bulkAdding && setShowBulkImport(false)}>
              <div className="rounded-2xl p-6 w-full max-w-3xl max-h-[90vh] overflow-y-auto" style={{...card, background:"#1a1a2e"}} onClick={e => e.stopPropagation()}>
                <div className="flex justify-between items-center mb-4">
                  <h3 className="text-lg font-semibold text-white">📥 Import lista susținători</h3>
                  <button onClick={() => setShowBulkImport(false)} disabled={bulkAdding}
                    className="text-xl px-2 rounded hover:bg-white/10" style={{color:"rgba(255,255,255,0.4)"}}>✕</button>
                </div>

                {bulkResults.length === 0 ? (
                  <div className="space-y-3">
                    <div>
                      <label className="text-xs mb-1 block" style={{color:"rgba(255,255,255,0.4)"}}>Coordonator (opțional)</label>
                      <input className="w-full rounded-xl px-3 py-2.5 text-sm" style={inputStyle}
                        placeholder="Ex: Maria Coordonator"
                        value={bulkManager}
                        list="wl-managers-list-bulk"
                        onChange={e => setBulkManager(e.target.value)} />
                      <datalist id="wl-managers-list-bulk">
                        {whitelistManagers.map((m, i) => (
                          <option key={i} value={m.manager}>{m.count} susținători</option>
                        ))}
                      </datalist>
                    </div>
                    <div>
                      <label className="text-xs mb-1 block" style={{color:"rgba(255,255,255,0.4)"}}>Nume (unul per linie)</label>
                      <textarea className="w-full rounded-xl px-3 py-2.5 text-sm font-mono" style={{...inputStyle, minHeight: "200px"}}
                        placeholder={"Mirela Avram\nMadalina Avram\nStefania Iovan\n..."}
                        value={bulkText}
                        onChange={e => setBulkText(e.target.value)} />
                      <p className="text-xs mt-1" style={{color:"rgba(255,255,255,0.3)"}}>
                        {bulkText.split("\n").map(s => s.trim()).filter(Boolean).length} nume
                      </p>
                    </div>
                    <div className="flex gap-2">
                      <button onClick={doBulkSearch} disabled={bulkSearching || !bulkText.trim()}
                        className="px-4 py-2 rounded-xl text-sm font-medium disabled:opacity-50" style={btnPrimary}>
                        {bulkSearching ? "Caut..." : "🔍 Caută în BD"}
                      </button>
                      <button onClick={() => setShowBulkImport(false)}
                        className="px-4 py-2 rounded-xl text-sm font-medium" style={btnGray}>
                        Anulează
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="space-y-3">
                    <div className="text-xs flex flex-wrap gap-4 pb-2 border-b" style={{color:"rgba(255,255,255,0.4)",borderColor:"rgba(255,255,255,0.1)"}}>
                      <span>✓ {bulkResults.filter(r => r.status === "found_clean").length} clari</span>
                      <span>⚠ {bulkResults.filter(r => r.status === "found_mixed").length} micști</span>
                      <span>🚫 {bulkResults.filter(r => r.status === "found_bad").length} probleme</span>
                      <span>⭐ {bulkResults.filter(r => r.status === "already_whitelisted").length} deja</span>
                      <span>❌ {bulkResults.filter(r => r.status === "not_found").length} negăsiți</span>
                      <span className="ml-auto font-semibold text-yellow-300">Selectați: {Object.keys(bulkSelected).length}</span>
                    </div>
                    <div className="space-y-2 max-h-[50vh] overflow-y-auto">
                      {bulkResults.map((r, i) => {
                        const isAlready = r.status === "already_whitelisted";
                        const isNotFound = r.status === "not_found";
                        const isBad = r.status === "found_bad";
                        const isMixed = r.status === "found_mixed";

                        const borderColor = isAlready ? "rgba(234,179,8,0.3)" : isNotFound ? "rgba(255,255,255,0.1)" : isBad ? "rgba(239,68,68,0.3)" : isMixed ? "rgba(245,158,11,0.3)" : "rgba(74,222,128,0.3)";
                        const statusBadge = isAlready ? {label:"⭐ deja", color:"#fde047"} : isNotFound ? {label:"❌ negăsit", color:"rgba(255,255,255,0.4)"} : isBad ? {label:"🚫 probleme", color:"#fca5a5"} : isMixed ? {label:"⚠ mixt", color:"#fcd34d"} : {label:"✓ curat", color:"#86efac"};

                        return (
                          <div key={i} className="rounded-lg p-3" style={{background:"rgba(255,255,255,0.03)",border:`1px solid ${borderColor}`}}>
                            <div className="flex items-center justify-between mb-1">
                              <span className="text-sm font-medium text-white">{r.name}</span>
                              <span className="text-xs" style={{color: statusBadge.color}}>{statusBadge.label}</span>
                            </div>
                            {r.candidates && r.candidates.length > 0 && r.candidates.map((c, j) => (
                              <label key={j} className="flex items-center gap-2 mt-1 cursor-pointer p-2 rounded hover:bg-white/5">
                                <input type="checkbox" disabled={isAlready}
                                  checked={!!bulkSelected[c.from_id]}
                                  onChange={() => toggleBulkSelected(c)} />
                                <div className="flex-1 min-w-0">
                                  <p className="text-sm text-white">{c.from_name}</p>
                                  <p className="text-xs font-mono" style={{color:"rgba(255,255,255,0.3)"}}>{c.from_id} · {c.total_comments} com</p>
                                  <p className="text-xs" style={{color:"rgba(255,255,255,0.4)"}}>
                                    sus:{c.sustinator} critic:{c.critic} troll:{c.troll} neutru:{c.neutru}
                                    {(c.hidden > 0 || c.blocked > 0) && <span style={{color:"#fca5a5"}}> · h:{c.hidden} b:{c.blocked}</span>}
                                  </p>
                                </div>
                              </label>
                            ))}
                            {isNotFound && (
                              <p className="text-xs mt-1" style={{color:"rgba(255,255,255,0.3)"}}>
                                Voluntar nou? Așteaptă primul comentariu și adaugă-l individual.
                              </p>
                            )}
                          </div>
                        );
                      })}
                    </div>
                    <div className="flex gap-2 pt-3 border-t" style={{borderColor:"rgba(255,255,255,0.1)"}}>
                      <button onClick={doBulkAdd} disabled={bulkAdding || Object.keys(bulkSelected).length === 0}
                        className="px-4 py-2 rounded-xl text-sm font-medium disabled:opacity-50" style={btnPrimary}>
                        {bulkAdding ? `Adaug...` : `Adaugă ${Object.keys(bulkSelected).length} selecții`}
                      </button>
                      <button onClick={() => { setBulkResults([]); setBulkSelected({}); }} disabled={bulkAdding}
                        className="px-4 py-2 rounded-xl text-sm font-medium" style={btnGray}>
                        ← Înapoi
                      </button>
                      <button onClick={() => setShowBulkImport(false)} disabled={bulkAdding}
                        className="px-4 py-2 rounded-xl text-sm font-medium ml-auto" style={btnGray}>
                        Anulează
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {showAddWhitelist && (
            <div className="rounded-2xl p-5 mb-4" style={card}>
              <h4 className="font-semibold text-white mb-4">User nou în whitelist</h4>
              <div className="space-y-3">
                <div className="relative">
                  <label className="text-xs mb-1 block" style={{color:"rgba(255,255,255,0.4)"}}>Nume</label>
                  <input className="w-full rounded-xl px-3 py-2.5 text-sm" style={inputStyle}
                    placeholder="Scrie numele — caută automat în BD"
                    value={newWhitelistUser.from_name}
                    onChange={e => searchWhitelistUser(e.target.value)} />
                  {whitelistSearching && (
                    <p className="text-xs mt-1" style={{color:"rgba(255,255,255,0.3)"}}>Se caută...</p>
                  )}
                  {whitelistSearch.length > 0 && (
                    <div className="absolute z-10 w-full mt-1 rounded-xl overflow-hidden" style={{background:"#1e1e2e",border:"1px solid rgba(255,255,255,0.1)"}}>
                      {whitelistSearch.map((u, i) => (
                        <button key={i} onClick={() => selectWhitelistUser(u)}
                          className="w-full px-4 py-2.5 text-left hover:bg-white/5 transition-all">
                          <p className="text-sm text-white">{u.from_name}</p>
                          <p className="text-xs font-mono" style={{color:"rgba(255,255,255,0.3)"}}>{u.from_id} · {u.total_comments} comentarii</p>
                        </button>
                      ))}
                    </div>
                  )}
                  {whitelistSearch.length === 0 && newWhitelistUser.from_name.length >= 3 && !whitelistSearching && (
                    <p className="text-xs mt-1" style={{color:"rgba(255,255,255,0.3)"}}>Negăsit în BD — introdu ID manual</p>
                  )}
                </div>
                <div>
                  <label className="text-xs mb-1 block" style={{color:"rgba(255,255,255,0.4)"}}>Facebook ID</label>
                  <input className="w-full rounded-xl px-3 py-2.5 text-sm font-mono" style={inputStyle}
                    placeholder="Completat automat sau introdu manual"
                    value={newWhitelistUser.from_id}
                    onChange={e => setNewWhitelistUser(prev => ({...prev, from_id: e.target.value}))} />
                </div>
                <div>
                  <label className="text-xs mb-1 block" style={{color:"rgba(255,255,255,0.4)"}}>Note (opțional)</label>
                  <input className="w-full rounded-xl px-3 py-2.5 text-sm" style={inputStyle}
                    placeholder="Ex: Voluntar echipă"
                    value={newWhitelistUser.notes}
                    onChange={e => setNewWhitelistUser(prev => ({...prev, notes: e.target.value}))} />
                </div>
                <div>
                  <label className="text-xs mb-1 block" style={{color:"rgba(255,255,255,0.4)"}}>Coordonator (opțional)</label>
                  <input className="w-full rounded-xl px-3 py-2.5 text-sm" style={inputStyle}
                    placeholder="Ex: Maria Coordonator — sau lasă gol"
                    value={newWhitelistUser.manager}
                    list="wl-managers-list"
                    onChange={e => setNewWhitelistUser(prev => ({...prev, manager: e.target.value}))} />
                  <datalist id="wl-managers-list">
                    {whitelistManagers.map((m, i) => (
                      <option key={i} value={m.manager}>{m.count} susținători</option>
                    ))}
                  </datalist>
                </div>
              </div>
              <div className="flex gap-2 mt-4">
                <button onClick={addToWhitelist}
                  disabled={!newWhitelistUser.from_id || !newWhitelistUser.from_name}
                  className="px-4 py-2 rounded-xl text-sm font-medium disabled:opacity-50" style={btnPrimary}>
                  Adaugă
                </button>
                <button onClick={() => setShowAddWhitelist(false)}
                  className="px-4 py-2 rounded-xl text-sm font-medium" style={btnGray}>
                  Anulează
                </button>
              </div>
            </div>
          )}

          {/* MODAL EDIT MANAGER */}
          {editingItem && (
            <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{background:"rgba(0,0,0,0.7)"}} onClick={() => !editingMgrSaving && setEditingItem(null)}>
              <div className="rounded-2xl p-6 w-full max-w-md" style={{...card, background:"#1a1a2e"}} onClick={e => e.stopPropagation()}>
                <h3 className="text-lg font-semibold text-white mb-4">✏️ Editează coordonator</h3>
                <p className="text-sm mb-3" style={{color:"rgba(255,255,255,0.6)"}}>
                  Pentru: <span className="text-white font-medium">{editingItem.from_name}</span>
                </p>
                <label className="text-xs mb-1 block" style={{color:"rgba(255,255,255,0.4)"}}>Coordonator (gol = fără)</label>
                <input className="w-full rounded-xl px-3 py-2.5 text-sm" style={inputStyle}
                  placeholder="Ex: Maria Coordonator (sau lasă gol)"
                  value={editingMgrValue}
                  autoFocus
                  onKeyDown={e => { if (e.key === "Enter") saveEditingManager(); if (e.key === "Escape") setEditingItem(null); }}
                  onChange={e => setEditingMgrValue(e.target.value)} />
                {whitelistManagers.length > 0 && (
                  <div className="mt-3">
                    <p className="text-xs mb-2" style={{color:"rgba(255,255,255,0.3)"}}>Coordonatori existenți (click pentru selectare):</p>
                    <div className="flex flex-wrap gap-1.5">
                      {whitelistManagers.map((m, i) => (
                        <button key={i} type="button" onClick={() => setEditingMgrValue(m.manager)}
                          className="px-2.5 py-1 rounded-lg text-xs"
                          style={{
                            background: editingMgrValue === m.manager ? "rgba(124,58,237,0.3)" : "rgba(255,255,255,0.05)",
                            border: editingMgrValue === m.manager ? "1px solid rgba(124,58,237,0.5)" : "1px solid rgba(255,255,255,0.1)",
                            color: editingMgrValue === m.manager ? "#c4b5fd" : "rgba(255,255,255,0.7)"
                          }}>
                          {m.manager} <span style={{opacity:0.5}}>({m.count})</span>
                        </button>
                      ))}
                    </div>
                  </div>
                )}
                <div className="flex gap-2 mt-5">
                  <button onClick={saveEditingManager} disabled={editingMgrSaving}
                    className="px-4 py-2 rounded-xl text-sm font-medium disabled:opacity-50" style={btnPrimary}>
                    {editingMgrSaving ? "Salvez..." : "Salvează"}
                  </button>
                  <button onClick={() => setEditingItem(null)} disabled={editingMgrSaving}
                    className="px-4 py-2 rounded-xl text-sm font-medium ml-auto" style={btnGray}>
                    Anulează
                  </button>
                </div>
              </div>
            </div>
          )}

          <div className="space-y-3">
            {whitelistGroups.length === 0 && (
              <div className="text-center py-12 text-sm" style={{color:"rgba(255,255,255,0.25)"}}>Niciun user pe whitelist.</div>
            )}
            {whitelistGroups.map(grp => {
              const isExpanded = expandedManagers[grp.manager] !== false; // default expanded
              return (
                <div key={grp.manager} className="rounded-xl overflow-hidden" style={{...card, border:"1px solid rgba(234,179,8,0.15)"}}>
                  <button onClick={() => setExpandedManagers(prev => ({...prev, [grp.manager]: !isExpanded}))}
                    className="w-full px-4 py-3 flex items-center justify-between hover:bg-white/5 transition-all">
                    <div className="flex items-center gap-3">
                      <span className="text-lg" style={{color:"rgba(255,255,255,0.5)"}}>{isExpanded ? "▼" : "▶"}</span>
                      <span className="font-semibold text-white">{grp.manager}</span>
                      <span className="px-2 py-0.5 rounded-md text-xs" style={{background:"rgba(234,179,8,0.15)",color:"#fde047"}}>{grp.count}</span>
                    </div>
                  </button>
                  {isExpanded && (
                    <div className="px-3 pb-3 space-y-2">
                      {grp.items.map(user => (
                        <div key={user.from_id} className="rounded-lg p-3 flex items-center justify-between" style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(234,179,8,0.1)"}}>
                          <div className="flex items-center gap-3">
                            <div className="w-7 h-7 rounded-lg flex items-center justify-center text-sm"
                              style={{background:"linear-gradient(135deg,#eab308,#ca8a04)",color:"white"}}>
                              ⭐
                            </div>
                            <div>
                              <p className="text-sm font-medium text-white">{user.from_name}</p>
                              <p className="text-xs font-mono" style={{color:"rgba(255,255,255,0.3)"}}>{user.from_id} · {user.total_comments} com</p>
                              {user.notes && <p className="text-xs" style={{color:"rgba(255,255,255,0.4)"}}>{user.notes}</p>}
                            </div>
                          </div>
                          <div className="flex items-center gap-2">
                            <span className="text-xs hidden md:inline" style={{color:"rgba(255,255,255,0.25)"}}>
                              {new Date(user.added_at).toLocaleDateString('ro-RO')}
                            </span>
                            <button onClick={() => openEditManager(user)}
                              className="px-3 py-1.5 rounded-lg text-xs font-medium" style={btnGray}
                              title="Editează coordonator">
                              ✏️
                            </button>
                            <button onClick={() => removeFromWhitelist(user.from_id)}
                              className="px-3 py-1.5 rounded-lg text-xs font-medium" style={btnRed}>
                              Elimină
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {activeSection === "users" && (
        <div>
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-lg font-semibold text-white">Utilizatori</h3>
            <button onClick={() => setShowAddUser(!showAddUser)}
              className="px-4 py-2 rounded-xl text-sm font-medium" style={btnPrimary}>
              + Utilizator nou
            </button>
          </div>

          {userMessage && (
            <div className="rounded-xl p-3 mb-4 text-sm" style={userMessage.includes("Eroare")
              ? {background:"rgba(239,68,68,0.1)",border:"1px solid rgba(239,68,68,0.2)",color:"#fca5a5"}
              : {background:"rgba(34,197,94,0.1)",border:"1px solid rgba(34,197,94,0.2)",color:"#86efac"}}>
              {userMessage}
            </div>
          )}

          {showAddUser && (
            <div className="rounded-2xl p-5 mb-4" style={card}>
              <h4 className="font-semibold text-white mb-4">Utilizator nou</h4>
              <div className="space-y-3">
                <div>
                  <label className="text-xs mb-1 block" style={{color:"rgba(255,255,255,0.4)"}}>Username</label>
                  <input className="w-full rounded-xl px-3 py-2.5 text-sm" style={inputStyle}
                    placeholder="username"
                    value={newUser.username}
                    onChange={e => setNewUser(prev => ({...prev, username: e.target.value}))} />
                </div>
                <div>
                  <label className="text-xs mb-1 block" style={{color:"rgba(255,255,255,0.4)"}}>Parolă</label>
                  <input type="password" className="w-full rounded-xl px-3 py-2.5 text-sm" style={inputStyle}
                    placeholder="••••••••"
                    value={newUser.password}
                    onChange={e => setNewUser(prev => ({...prev, password: e.target.value}))} />
                </div>
                <div>
                  <label className="text-xs mb-1 block" style={{color:"rgba(255,255,255,0.4)"}}>Rol</label>
                  <select className="w-full rounded-xl px-3 py-2.5 text-sm" style={inputStyle}
                    value={newUser.role}
                    onChange={e => setNewUser(prev => ({...prev, role: e.target.value}))}>
                    <option style={{color:"black"}} value="operator">Operator</option>
                    <option style={{color:"black"}} value="moderator">Moderator</option>
                    <option style={{color:"black"}} value="admin">Administrator</option>
                  </select>
                </div>
              </div>
              <div className="flex gap-2 mt-4">
                <button onClick={addUser} disabled={!newUser.username || !newUser.password}
                  className="px-4 py-2 rounded-xl text-sm font-medium disabled:opacity-50" style={btnPrimary}>
                  Creează
                </button>
                <button onClick={() => setShowAddUser(false)}
                  className="px-4 py-2 rounded-xl text-sm font-medium" style={btnGray}>
                  Anulează
                </button>
              </div>
            </div>
          )}

          <div className="space-y-2">
            {users.map(user => (
              <div key={user.id} className="rounded-xl p-4" style={card}>
                <div className="flex justify-between items-center">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold"
                      style={{background:"linear-gradient(135deg,#6366f1,#8b5cf6)",color:"white"}}>
                      {user.username.charAt(0).toUpperCase()}
                    </div>
                    <div>
                      <p className="text-sm font-medium text-white">{user.username}</p>
                      <p className="text-xs" style={{color:"rgba(255,255,255,0.35)"}}>
                        {user.role === "admin" ? "Administrator" : user.role === "moderator" ? "Moderator" : "Operator"}
                      </p>
                    </div>
                  </div>
                  {user.username !== "admin" && (
                    <div className="flex gap-2 flex-wrap">
                      {(user.role === "operator" || user.role === "moderator") && (
                        <button onClick={() => openPermissions(user)}
                          className="px-3 py-1.5 rounded-xl text-xs font-medium"
                          style={{background:"rgba(99,102,241,0.15)",border:"1px solid rgba(99,102,241,0.3)",color:"#a5b4fc"}}>
                          🔐 Permisiuni
                        </button>
                      )}
                      <button onClick={() => setEditUser(editUser?.id === user.id ? null : user)}
                        className="px-3 py-1.5 rounded-xl text-xs font-medium" style={btnGray}>
                        Editează
                      </button>
                      <button onClick={() => deleteUser(user.id)}
                        className="px-3 py-1.5 rounded-xl text-xs font-medium" style={btnRed}>
                        Șterge
                      </button>
                    </div>
                  )}
                </div>
                {editUser?.id === user.id && (
                  <div className="mt-3 pt-3 space-y-3" style={{borderTop:"1px solid rgba(255,255,255,0.06)"}}>
                    <div>
                      <label className="text-xs mb-1 block" style={{color:"rgba(255,255,255,0.4)"}}>Rol</label>
                      <select className="w-full rounded-xl px-3 py-2 text-sm" style={inputStyle}
                        value={editUser.role}
                        onChange={e => setEditUser(prev => ({...prev, role: e.target.value}))}>
                        <option style={{color:"black"}} value="operator">Operator</option>
                        <option style={{color:"black"}} value="moderator">Moderator</option>
                        <option style={{color:"black"}} value="admin">Administrator</option>
                      </select>
                    </div>
                    <div>
                      <label className="text-xs mb-1 block" style={{color:"rgba(255,255,255,0.4)"}}>Parolă nouă (opțional)</label>
                      <input type="password" className="w-full rounded-xl px-3 py-2 text-sm" style={inputStyle}
                        placeholder="Lasă gol pentru a păstra parola actuală"
                        value={editUser.newPassword || ""}
                        onChange={e => setEditUser(prev => ({...prev, newPassword: e.target.value}))} />
                    </div>
                    <div className="flex gap-2">
                      <button onClick={async () => {
                        try {
                          await axios.put(`${API}/auth/users/${editUser.id}`, {
                            role: editUser.role,
                            password: editUser.newPassword || undefined
                          });
                          setUserMessage("User actualizat cu succes!");
                          setEditUser(null);
                          const res = await axios.get(`${API}/auth/users`);
                          setUsers(res.data.users);
                        } catch(e) { setUserMessage("Eroare la actualizare!"); }
                      }} className="px-4 py-2 rounded-xl text-sm font-medium" style={btnPrimary}>
                        Salvează
                      </button>
                      <button onClick={() => setEditUser(null)}
                        className="px-4 py-2 rounded-xl text-sm font-medium" style={btnGray}>
                        Anulează
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

    </div>
  );
}
